(function() {
    var docEl = document.documentElement,
        docStyle = docEl.style;

    $.extend(fp, {
        device: {
            hasTouch: 'ontouchstart' in docEl,
            hasFlex: docStyle && ('flexWrap' in docStyle) || ('WebkitFlexWrap' in docStyle) || ('msFlexWrap' in docStyle),
            usingMouse: false,
            xs: false,
            sm: false,
            md: false,
            lg: false,
            portrait: false
        },
        timeZone: window.Intl && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions().timeZone,
        adminRoles: _.toArray(fpConstants.adminRole),
        vendorImageUrl: fp.assetCdnUrl + 'vendor/',
        productFields: 'id,identifier,attribution_token,reference_id,reference_ids,upc,name,store_id,department_id,size,cover_image,price,sale_price,sale_price_md,sale_start_date,sale_finish_date,price_disclaimer,sale_price_disclaimer,is_favorite,relevance,popularity,shopper_walkpath,fulfillment_walkpath,quantity_step,quantity_minimum,quantity_initial,quantity_label,quantity_label_singular,varieties,quantity_size_ratio_description,status,status_id,sale_configuration_type_id,fulfillment_type_id,fulfillment_type_ids,other_attributes,clippable_offer,slot_message,call_out,has_featured_offer,tax_class_label,promotion_text,sale_offer,store_card_required,average_rating,review_count,like_code,shelf_tag_ids,offers,is_place_holder_cover_image,video_config,enforce_product_inventory,disallow_adding_to_cart,substitution_type_ids,unit_price,offer_sale_price',
        defaultDepartment: {id: '0'},
        defaultCategory: {id: '0'},
        mobileWebUrl: 'https://{0}mobile.freshopsites.com',
        department: {},
        departments: [],
        departmentHash: {},
        digitalCouponsSettings: {},
        productConfigurationConfig: {},
        storeCardSettings: {},
        defaultList: {
            id: '0',
            name: 'My List'
        },
        isSingleStore: false,
        disableHasTracked: true,
        enableCache: true,
        cache: {
            product: {
                items: {}
            },
            lists: {},
            template: {},
            authorization: {},
            hashedStoreSettings: {
                siteUrls: {}
            },
            file: {}
        },
        defaultScope: {
            __type: 'fpScope',
            fp: fp,
            $: $,
            _: _,
            dateFns: dateFns,
            jss: jss,
            showdown: showdown,
            Lockr: Lockr,
            util: fpUtil,
            states: fpConfig.routeStates,
            constants: fpConstants
        },
        apiQueue: {},
        multiplexQueue: {},
        alertQueue: [],
        apiErrorQueue: [],
        serverDateFormat: 'YYYY-MM-DD',
        serverTimeFormat: 'HH:mm:ss',
        serverDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
        routeDelimiter: '#!',
        prevRoute: [],
        currentRoute: [],
        routeUrlParams: {},
        //1 x 1 transparent gif
        //blankImageUrl: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
        //256 x 256 transparent gif works better for product grid as image expand properly
        blankImageUrl: 'data:image/gif;base64,R0lGODlhAAEAAYAAAP///////yH5BAEKAAEALAAAAAAAAQABAAL+jI+py+0Po5y02ouz3rz7D4biSJbmiabqyrbuC8fyTNf2jef6zvf+DwwKh8Si8YhMKpfMpvMJjUqn1Kr1is1qt9yu9wsOi8fksvmMTqvX7Lb7DY/L5/S6/Y7P6/f8vv8PGCg4SFhoeIiYqLjI2Oj4CBkpOUlZaXmJmam5ydnp+QkaKjpKWmp6ipqqusra6voKGys7S1tre4ubq7vL2+v7CxwsPExcbHyMnKy8zNzs/AwdLT1NXW19jZ2tvc3d7f0NHi4+Tl5ufo6err7O3u7+Dh8vP09fb3+Pn6+/z9/v/w8woMCBBAsaPIgwocKFDBs6fAgxosSJFCtavIgxo8ZgjRw7evwIMqTIkSRLmjyJMqXKlSxbunwJM6bMmTRr2ryJM6fOnTx7+vwJNKjQoUSLGj2KNKnSpUybOn0KNarUqVSrWr2KNavWrVy7ev0KNqzYsWTLmj2LNq3atWzbHisAADs=',
        currency: {
            currency_iso_code: 'USD'
        },
        //all supported locales
        locales: [
            'en',
            'en-ca',
            'es',
            'fr',
            'zh-hans',
            'zh-hant',
        ],
        earlyModules: [
            'redirect',
            'siteHeader',
            //'siteFooter',
            'skipToMainContent',
            'userSessionIndicator',
            'userStoreIndicator',
            //'miniListIndicator',
            'searchBox'
        ],
        storeRequiredApis: [
            'products',
            'product_search_suggestions',
            // 'recipes' store id is implemented in recipeService,
            // 'recipe_items' store id is implemented in recipeItemService,
            'offers',
            'circulars',
            'circular_pages',
            'departments',
            'search',
            'shopping_lists',
            'shopping_list_items',
            'user_products',
            //'tags',
            'service_provider_configurations',
            'recipe_filters',
            'user_product_buys',
            'user_product_upsell'
        ],
        defaultStoreRequiredApiParams: {
            as_of_date: 'as_of_date',
            date: 'as_of_date'
        },
        adContextFields: [
            'product_id',
            'department_id',
            'category_id',
            'filter_id',
            'shelf_tag_id',
            'tag_id',
            'for_circular_id',
            'for_circular_type_id',
            'for_offer_type_id'
        ],
        componentHtml: ' \
            <script type="text/template" data-id="component/0/store-change-products.html"> \
                <p> \
                    <%= availability %> \
                    <%= checkList %> \
                    <%= switchBack %> \
                </p> \
            </script> \
            <script type="text/template" data-id="component/0/order-store-change.html"> \
                <p class="fp-text-uppercase fp-semibold"> \
                    <%= orderProgress %> \
                </p> \
            </script> \
            <script type="text/template" data-id="component/0/user-store-change.html"> \
                <p><%= fp.ui.locale(\'ui-store-changed\', \'Your preferred store was changed by a different session.\') %></p> \
            </script> \
            <script type="text/template" data-id="component/0/store-change.html"> \
                <%= userStoreChange %> \
                <%= orderStoreChange %> \
                <p><%= fp.ui.localef(\'ui-update-store\', \'Continuing will update your selected store to <span class="fp-semibold">{0}</span>.\', storeName) %> </p> \
                <%= storeChangeProduct %> \
                <p><%= fp.ui.locale(\'ui-sure-update\', \'Are you sure you want to update your store?\') %></p> \
            </script> \
            <script type="text/template" data-id="component/0/animated-loading.html"> \
                <span class="fp-animated-loading" data-role="animated-loading"> \
                    <% for(var n=1;n<=8;n++) { %> \
                    <span class="fp-circle fp-circle-<%= n %>"></span> \
                    <% } %> \
                </span> \
            </script> \
            <script type="text/template" data-id="component/0/freshop.html"> \
                <div class="fp-core fp-freshop fp-freshop-loading" data-role="freshop-container"> \
                    <div class="fp-request fp-error" style="display:none;"> \
                        <span class="fp-value"><%- fp.ui.locale(\'shared-error-request\', \'An error has occurred making your request\') %></span>. \
                        <a href="javascript:;"><%- fp.ui.locale(\'shared-click-here\', \'Click here to try again\') %></a>. \
                    </div> \
                    <div class="fp-font-preload" style="opacity: 0;filter: alpha(opacity=0);"> \
                        <span style="font-family:freshopicons;"></span> \
                    </div> \
                    <div class="fp-modal-container" data-role="modal-container"></div> \
                    <div class="fp-dropdown-container" data-role="dropdown-container"></div> \
                    <div data-role="tracking"></div> \
                    <%= util.getStateValue(fp.ui.router.routeManager.hasXhrPageLoad, \'<a href="#" aria-label="Next" data-role="next"></a>\') %> \
                </div> \
            </script> \
            <script type="text/template" data-id="component/0/loading.html"> \
                <div class="fp-request fp-loading" style="display:none;"></div> \
            </script> \
        ',
        __$freshop: $(),
        initUI: function(config) {
            var routeManager = fpUi.router.routeManager,
                stateManager = fpUi.router.stateManager,
                uiConfig;

            //render ID is a unique id assigned for each route change
            fp.renderId = _.now();
            fp.enableMobile = fp.bowser.mobile || fp.bowser.tablet;
            fp.locale = routeManager.locale();

            //temporarily assign apiBaseUrl #FO-1091
            fp.isGcpAdmin = fpUi.router.location.isCurrentHost(fpConfig.gcpAdminUrl);

            //randomize which apiBaseUrl to use
            if(_.isArray(fp.apiBaseUrls) && fp.apiBaseUrls.length > 1) {
                var hashKey = fp.getCookie('fp-cache').api_base_url,
                    length = fp.apiBaseUrls.length,
                    apiBaseUrl;
                if (hashKey) {
                    //lookup session's apiBaseUrl based off of hash key
                    apiBaseUrl = _.find(fp.apiBaseUrls, function (value) {
                        return hashKey == fpUi.getHash(value, length);
                    });
                }
                if (!apiBaseUrl) {
                    var lastApiBaseUrl = apiBaseUrl = fp.getSessionCookie().api_base_url;
                    while(apiBaseUrl === lastApiBaseUrl) {
                        apiBaseUrl = fp.apiBaseUrls[_.random(length - 1)];
                    }
                    fp.setCookie('fp-cache', {api_base_url: fpUi.getHash(apiBaseUrl, length)}, dateFns.addMinutes(new Date(), 15));
                    fp.setSessionCookie({api_base_url: apiBaseUrl})
                }
                fp.apiBaseUrl = apiBaseUrl;
            }

            // if(fp.isLocal()) {
            //     config.enableRouteDomain = true;
            // }

            /* if(config.intent != 'admin' && !_.size(config.locales)) {
                config.enableLocale = false;
            }

            if (config.enableLocale) {
                fpConfig.enableLocale = true;
                if(_.size(config.locales)) {
                    if (_.has(fpConfig, 'locales')) $.extend(fpConfig.locales, config.locales);
                    else fpConfig.locales = $.extend(true, [], config.locales);
                }
                fp.locale = routeManager.locale();

                if (fp.locale != 'en' && _.size(fpConfig.locales) > 1) {
                    return fpService.storeConfigurationService
                        .getByAssetKey({
                            mode: fp.configMode,
                            locale: fp.locale
                        })
                        .then(function (resp) {
                            $.extend(true, config, resp);
                        });
                }
            } */

            fpService.storeConfigurationService
                .getByAssetKey({
                    mode: fp.configMode,
                    locale: fp.locale
                })
                .then(function (resp) {
                    $.extend(true, config, resp);

                    if(config.intent != 'admin' && !_.size(config.locales)) {
                        config.enableLocale = false;
                    }
        
                    if (config.enableLocale) {
                        fpConfig.enableLocale = true;
                        if(_.size(config.locales)) {
                            if (_.has(fpConfig, 'locales')) $.extend(fpConfig.locales, config.locales);
                            else fpConfig.locales = $.extend(true, [], config.locales);
                        }
                        fp.locale = routeManager.locale();
                    }

                    var promiseMap = fpUtil.map.load({
                            service: fpService.serviceProviderConfigurationService,
                            payload: {
                                service_provider_type: 'user_authentication_type'
                            }
                        }),
                        promiseUiConfig;

                    if(config.enableUiConfigOverride == undefined) config.enableUiConfigOverride = fpConfig.enableUiConfigOverride;
                    if(config.enableUiConfigOverride) {
                        const storeId = fp.getSelectedStoreId();
                        promiseUiConfig = fpService.serviceProviderConfigurationService
                            .get({
                                service_provider_type: 'store_setting',
                                service_provider: 'ui_config' + (fp.uiConfigMode ? `_${fp.uiConfigMode}` : ''),
                                store_id: storeId
                            }, {
                                prepareJsonData: false,
                                handleErrors: false
                            })
                            .then(function(resp) {
                                if(_.size(resp.items) > 1 && storeId) {
                                    uiConfig = _.findWhere(resp.items, {store_id: storeId})?.config;
                                }
                                if(!uiConfig) {
                                    uiConfig = _.first(resp.items)?.config;
                                }

                                return fpService.serviceProviderConfigurationService
                                    .get({
                                        service_provider_type: 'store_setting',
                                        service_provider: 'ui_config',
                                        store_id: fpConfig.globalStoreId
                                    }, {
                                        prepareJsonData: false,
                                        handleErrors: false
                                    })
                                    .then(function(resp) {
                                        fpConfig.bugsnag = _.first(resp.items)?.config?.bugsnag;
                                    });
                            });
                    }

                    //check if app supports mobile web
                    // if(fp.enableMobile && !config.enableMobile && !fp.isLocal() && !fp.isProd()) {
                    //     promiseConfig = fpService.storeConfigurationService
                    //         .getMobileWebAppKey()
                    //         .then(function(appKey) {
                    //             if(appKey) {
                    //                 window.location.href = fpUtil.formatString(fp.mobileWebUrl, fp.appKey);
                    //                 return $.Deferred().promise();
                    //             }
                    //         },
                    //         function() {
                    //             return $.when();
                    //         });
                    // }

                    return $.when(promiseMap, promiseUiConfig)
                        .then(function() {
                            if(uiConfig) {
                                const uiConfigModules = uiConfig.modules;
                                delete uiConfig.modules;
                                $.extend(true, config, uiConfig);
                                uiConfig.modules = uiConfigModules;

                                _.each(uiConfig.modules, function(uiConfigModule, key) {
                                    let configModule = config.modules[key];
                                    if(configModule) {
                                        if(_.isArray(configModule) || _.isArray(uiConfigModule)) {
                                            if(!_.isArray(configModule)) {
                                                configModule = config.modules[key] = [configModule];
                                            }
                                            if(!_.isArray(uiConfigModule)) {
                                                uiConfigModule = [uiConfigModule];
                                            }
                                            _.extendObjectArray(configModule, uiConfigModule, 'elementSelector');
                                        }
                                        else {
                                            $.extend(true, configModule, uiConfigModule);
                                        }
                                    }
                                    else {
                                        config.modules[key] = uiConfigModule;
                                    }
                                });
                            }

                            var subAppConfig = config.subAppConfig;
                            if(subAppConfig) {
                                delete config.subAppConfig;
                            
                                if(config.enableMobile) {
                                    //freshop mobile stores

                                    var modules = config.modules,
                                        subAppModules = subAppConfig.modules,
                                        oldUrls = subAppConfig.urls;

                                    //remove fields that should not be extended
                                    _.each([
                                        'containerClass', 'urls', 'fixedHeader', 'enableQtyDropDown', 'enableQuantityIndicator', 'enableModuleCss',
                                        'enableMultiplex', 'qtyDropDownMaxAmount', 'addToListLabel', 'inListLabel', 'disableOneClick', 'theme', 'resultLimits'
                                    ],
                                    function(key) {
                                        delete subAppConfig[key];
                                    });

                                    delete subAppConfig.modules;

                                    $.extend(true, config, subAppConfig);

                                    _.each(config.urls, function(key) {
                                        if(!oldUrls[key]) delete config.urls[key];
                                    });

                                    function extendModules (currentModules, extendModules) {
                                        _.each(currentModules, function(value, key) {
                                            _.each(extendModules[key], function (item) {
                                                if(item.version != 2) {
                                                    if(item.modules && value.modules) {
                                                        extendModules(value.modules, item.modules);
                                                        delete item.modules;
                                                    }
                                                    $.extend(true, value, _.omit(item, 'elementSelector'));
                                                }
                                            });
                                        });
                                    }

                                    extendModules(modules, subAppModules);
                                }
                                else {
                                    //freshop direct stores
                                    var oldSiteTitle = config.siteTitle,
                                        newSiteTitle = subAppConfig.siteTitle,
                                        modules = fpUtil.getValueFromNamespace('modules.account.modules', config);

                                    _.each(['siteTitle', 'siteLogo', 'rectangleLogo', 'mobileLogo'], function(key) {
                                        config[key] = subAppConfig[key];
                                    });

                                    var label = fpUtil.getValueFromNamespace('login.createAccountLabel', modules);
                                    if(label) modules.login.createAccountLabel = label.replaceAll(oldSiteTitle, newSiteTitle);

                                    label = fpUtil.getValueFromNamespace('create.subTitle', modules);
                                    if(label) modules.create.subTitle = label.replaceAll(oldSiteTitle, newSiteTitle);

                                    var defaultSort = fpUtil.getValueFromNamespace('products.defaultSort', subAppConfig.modules);
                                    if(defaultSort) config.modules.products.defaultSort = defaultSort;

                                    config.disableInitializeShopping = false;
                                }
                            }
                        });
                })
                .always(function() {
                    //replay any queued bugsnag reports
                    fp.notifier.__initialized = true;
                    _.each(fp.notifier.__queue, function(item) {
                        fp.notifier.notify(item);
                    });
                    delete fp.notifier.__queue;

                    var configModules = $.extend(true, {}, fpConfig.modules),
                        configUrls = $.extend(true, {}, fpConfig.urls),
                        configStoreCard = $.extend(true, {}, fpConfig.storeCard),
                        configSearchTypeahead = $.extend(true, {}, fpConfig.searchTypeahead),
                        clientRouteStates = config && config.routeStates;

                    if(clientRouteStates) delete config.routeStates;

                    //init default scope
                    $.extend(fp.defaultScope, {
                        stateManager: stateManager,
                        stateParams: stateManager.stateParams
                    });

                    if(!fp.__promiseStoreDependencies) {
                        fp.__promiseStoreDependencies = $.Deferred().promise();
                    }

                    //removeIf(!debug)

                    // if(!fp.isProd()) {
                    //     fp.disableRender = routeManager.urlParams.disable_render === 'true';
                    //     config.enableMultiplex = fpUtil.getBoolean(routeManager.urlParams.enable_multiplex, config.enableMultiplex && !fp.isLocal());
                    //     //fpConfig.enableModuleCss = fpUtil.getBoolean(routeManager.urlParams.enable_module_css, true);
                    // }

                    //endRemoveIf(!debug)

                    _.each(config.modules, function(value, key) {
                        if (S(key).endsWith('-exclude')) delete config.modules[key];
                    });
                    $.extend(fpConfig, config);

                    _.each(clientRouteStates, function(value, key) {
                        if(_.isObject(value) && _.has(value, 'menuSequence')) {
                            fpConfig.routeStates[key].menuSequence = value.menuSequence;
                        }
                    });

                    fpConfig.productDetailLayout = fpUtil.formatString('component/{0}/product-detail.html', S(fpConfig.productDetailLayout).trimLeft('layout-').s || '0');

                    //enable lazy init for new mobile
                    if(fpConfig.enableMobile && !_.has(config, 'enableLazyInit')) {
                        fpConfig.enableLazyInit = true;
                    }

                    if(fp.isBot) {
                        fpConfig.shopIntent.enabled = false;
                        fpConfig.requireStore = false;
                        fpConfig.enableWebCollage = false;
                    }

                    if(fpConfig.replaceCssColor) {
                        fpConfig.replaceCssColor = _.map(fpConfig.replaceCssColor, function(item) {
                            return {
                                start: S(fpUtil.hexToRgb(item.start)).trimRight(')').s,
                                end: S(fpUtil.hexToRgb(item.end)).trimRight(')').s
                            }
                        });
                    }

                    //fp.allowBots is set by freshop.js
                    //if this is true and fpConfig.enableSEO has not been disabled then default enableSEO to true
                    if(fp.allowBots && fpConfig.enableSEO !== false) {
                        fpConfig.enableSEO = true;
                        if(fpConfig.enableSEOPushState !== false) fpConfig.enableSEOPushState = true;
                    }

                    fp.Component.parseHtml(fp.componentHtml);

                    if(!fp.isProd() && _.has(routeManager.urlParams, 'enable_freshop_tracking')) {
                        fpConfig.enableFreshopTracking = fpUtil.getBoolean(routeManager.urlParams.enable_freshop_tracking, true);
                    }

                    if(fpConfig.enableFreshopTracking) {
                        var configTracking = fpConfig.modules.tracking;
                        if(!_.isArray(configTracking)) {
                            fpConfig.modules.tracking = configTracking = configTracking ? [configTracking] : [];
                        }
                        //var trackingModuleConfig = _.getObject(configTracking[0]);

                        //add freshop tracking module
                        configTracking.unshift({
                            elementSelector: 'body > [data-role="freshop-container"] > [data-role="tracking"]',
                            layout: 'layout-1',
                            gtmEnabled: true,
                            fbEnabled: false, //disable other 3rd party trackers as retailer tracking module will handle proper tracking
                            pinEnabled: false,
                            bingEnabled: false,
                            yelpEnabled: false,
                            intercomEnabled: false,
                            disableLoadGtag: fpConfig.disableLoadGtag,
                            gtmId: fpConfig.gtmId,
                            gaTrackingId: fpConfig.gaTrackingId,
                            liveAnalyticsEnabled: true/*,
                            enableOnPreProd: trackingModuleConfig.enableOnPreProd*/
                        });
                    }

                    //freshop module config takes precedence
                    var modules;
                    _.each(configModules, function(value, key) {
                        if(S(key).endsWith('-exclude')) {
                            delete configModules[key];
                            return;
                        }

                        if((modules = fpConfig.modules[key])) {
                            if (!_.isArray(modules)) modules = [modules];

                            _.each(modules, function (item) {
                                var layout = item && item.layout;

                                $.extend(true, item, value);

                                //ensure that layout is not forced by freshop module config
                                if (layout) item.layout = layout;

                                //if(key == 'checkout') {
                                //    _.each(item.modules, function (child) {
                                //        var hasModules = _.has(child, 'modules');
                                //        _.defaults(child, item);
                                //        if(!hasModules) delete child.modules;
                                //
                                //        fp.log('child', $.extend({}, child));
                                //    });
                                //}
                            });
                        }
                    });

                    //for testing purposes
                    // if(fp.isLocal()) {
                    //     var tempModuleKeys = [/* 'userStoreIndicator', */ 'miniListIndicator', 'miniList'],
                    //         tempModuleConfigs = {};

                    //     _.each(tempModuleKeys, function(key) {
                    //         if(fpConfig.modules[key]) tempModuleConfigs[key] = fpConfig.modules[key];
                    //     });
                            
                    //     // var temp1 = _.filter(fpConfig.modules.productCarousel, function(item) {
                    //     //         return item.elementSelector === '[data-role="product-carousel"]';
                    //     //     }),
                    //     //     temp2 = fpConfig.modules.miniListIndicator;

                    //     _.empty(fpConfig.modules);

                    //     _.each(tempModuleKeys, function(key) {
                    //         if(tempModuleConfigs[key]) fpConfig.modules[key] = tempModuleConfigs[key];
                    //     });
                    //     // fpConfig.modules.miniListIndicator = temp2;
                    // }

                    if(fpUtil.isNull(fpConfig.disableInitializeShopping)) {
                        fpConfig.disableInitializeShopping = fpConfig.intent == 'admin';
                    }
                    //$.fn.matchHeight._maintainScroll = fpUtil.getBoolean(fpConfig.disableSmartScrollResults && !fp.device.xs, false);

                    if(fpConfig.enableSEO) {
                        fp.productFields += ',canonical_url';

                        //putting these back as we tested and it no longer seems to be an issue
                        // _.each([
                        //     'productFavorite',
                        //     'productFavoriteParam',
                        //     'productFeatured',
                        //     'recipeFavorite',
                        //     'recipeFeatured'
                        // ], function(key) {
                        //     delete fpConfig.routeStates[key];
                        // });
                    }

                    if(fpConfig.guestCheckOut.enabled) {
                        var routeState;
                        _.each(['checkout'], function(key) {
                            routeState = fpConfig.routeStates[key];
                            if(routeState && routeState.data) routeState.data.authenticate = false;
                        })
                    }

                    _.defaults(fpConfig.urls, configUrls);
                    _.defaults(fpConfig.storeCard, configStoreCard);
                    _.defaults(fpConfig.searchTypeahead, configSearchTypeahead);

                    //need to load admin js as it has admin route states
                    var promiseBodyReady = $.when($.ready),
                        promiseDependencies;
                    if(fpConfig.intent == 'admin') {
                        promiseDependencies = fp.ui.loadFileDependencies('freshop-admin.js');
                    }

                    $.when(promiseDependencies)
                        .done(function() {
                            var startRegister = new Date();
                            fp.registerRouteStates();
                            //faster devices can run this in about 30ms
                            if(fpConfig.intent != 'admin') fp.reducedPerf = new Date() - startRegister > 90;

                            if(!fp.isProd() || (fp.isProd() && routeManager.urlParams.isProd == 'true')) {
                                //override apiBaseUrl if client config has apiBaseUrl defined
                                var apiBaseUrl = S(fpConfig.apiBaseUrl).trim();
                                if (apiBaseUrl.s) fp.apiBaseUrl = apiBaseUrl.ensureRight('/').s;
                            }

                            if(fpConfig.enableMobile) {
                                var localRoute;
                                _.each(_.concat(fpConfig.mobileUrls, fpConfig.mobileMenuConfig && fp.config.mobileMenuConfig.include), function(item) {
                                    if(item.url) {
                                        if(!fp.isProd()) {
                                            item.url = item.url
                                                .replace('www.', 'pre-prod-')
                                                .replace('.com', '.freshopsites.com');
                                        }
                                        if((localRoute = fpUi.router.location.isCurrentHost(item.url) ? item.url : routeManager.getLocalRoute(item.url))) {
                                            item.url = localRoute;
                                        }
                                        else {
                                            item.url = routeManager.buildUrl(item.url, {inherit: true, searchParams: {intent: 'in_app'}});
                                        }
                                    }
                                });
                            }

                            var $window = $(window),
                                windowSize = {
                                    width: $window.width(),
                                    height: $window.height()
                                };

                            $window
                                .on('resize', function() {
                                    var payload = {
                                        width: $window.width(),
                                        height: $window.height(),
                                        oldWidth: windowSize.width,
                                        oldHeight: windowSize.height
                                    };

                                    windowSize.width = payload.width;
                                    windowSize.height = payload.height;

                                    fp.trigger(fp.events.WINDOW_RESIZE, payload);
                                })
                                .on('orientationchange', function() {
                                    fp.trigger(fp.events.ORIENTATION_CHANGED);
                                })
                                .on('beforeunload', function() {
                                    fp.isUnloading = freshop.unloading = true;

                                    _.each(fp.apiQueue, function(item) {
                                        item.promise.deferred().reject('abort');
                                    });

                                    //$(window).add('*').off();
                                    //fp.Component.off();
                                })
                                .on('focus', function() {
                                    fp.hasFocus = true;
                                })
                                .on('blur', function() {
                                    fp.hasFocus = false;
                                });

                            const $html = $('html,body').on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchstart', function(event){
                                    if (!(event.which > 0 || _.contains(['mousedown', 'mousewheel', 'touchstart'], event.type))) return;

                                    $html.stop();
                                });
                            let promiseLocale;

                            //$(window).on('scroll' , function(event) {
                            //    fp.logStack('scroll')
                            //});

                            //load language pack and components first as there are some modal dependencies
                            if(fpConfig.enableLocale) {
                                promiseLocale = fpUi.loadFileDependencies('freshop-i18n.js')
                                    .then(function () {
                                        if(fp.locale != 'en') {
                                            return fp.api(fpUtil.formatString(
                                                    '{0}i18n/{1}.json',
                                                    fpConfig.enableLocaleClientJson ? (fp.assetAppKey + '/') : '',
                                                    fp.locale
                                                ), null, {
                                                    apiKey: 'sdk',
                                                    handleErrors: false
                                                })
                                                .then(function (resp) {
                                                    var locale = {};
                                                    locale[fp.locale] = resp;
                                                    $.i18n().load(locale);
                                                });
                                        }
                                    });
                            }

                            var promiseComponents = $.when(promiseLocale)
                                .then(function() {
                                    if(fpConfig.enableLocale) {
                                        $.i18n({
                                            locale: fp.locale
                                        });
                                        dateFns.locale(fp.locale);
                                    }

                                    var promiseDependencies = [],
                                        promiseDependency = fp.api('component/shared/component.html', null, {
                                            retryOnFail: false,
                                            queue: true,
                                            apiKey: 'sdk',
                                            dataType: 'text'
                                        })
                                        .then(function(data) {
                                            fp.Component.parseHtml(data);

                                            if(fpConfig.enableMobile) {
                                                //v2 components automatically overwrite existing
                                                return fp.api('component/shared/v2/component.html', null, {
                                                        retryOnFail: false,
                                                        queue: true,
                                                        apiKey: 'sdk',
                                                        dataType: 'text'
                                                    })
                                                    .then(function(data) {
                                                        fp.Component.parseHtml(data);
                                                    });
                                            }
                                        });

                                    promiseDependencies.push(promiseDependency);

                                    if(fpConfig.enableMobile) {
                                        promiseDependencies.push(fpUi.loadFileDependencies({
                                            src: 'freshop-component.css',
                                            prepend: true
                                        }));
                                    }

                                    return $.when.apply($, promiseDependencies);
                                }),
                                deferredEnsureActiveStore = $.Deferred(),
                                deferredLoadEarlyModules = $.Deferred();

                            var promiseInitUI = promiseComponents
                                .then(function() {
                                    initEvents();
                                    initMatchMedia();

                                    fp.client.initClientEvents();

                                    var deferredStoreDependencies = $.Deferred(),
                                        deferredList = $.Deferred(),
                                        initializeShopping = !fpConfig.disableInitializeShopping,
                                        urlParams = fpUi.router.routeManager.urlParams,
                                        promiseSession;

                                    if(urlParams.token && urlParams.token != fp.session.token && urlParams.token != fp.getSessionCookie().token) {
                                        promiseSession = fp.logout();
                                        const sessionPayload = {token: urlParams.token};
                                        //temporarily assign apiBaseUrl #FO-1091
                                        if(fpConfig.enableInitApiBaseUrl) sessionPayload.token_default = sessionPayload.token;
                                        fp.setSessionCookie(sessionPayload);
                                    }

                                    fp.listManager = new fp.ui.ListManager();

                                    promiseSession = $.when(promiseSession)
                                        .then(function() {
                                            return fp.initSession(true);
                                        })
                                        .then(function() {
                                            if(fp.session.store_id == fpConfig.globalStoreId) {
                                                fpConfig.disableInitializeShopping = true;
                                                initializeShopping = false;
                                            }

                                            routeManager.ensureRoute();

                                            //a redirect will trigger unload, in this case just simply exit
                                            if(fp.isUnloading) return;

                                            //load components and fulfillment types first
                                            const isAuthenticated = fpUtil.isAuthenticated();

                                            delete fp.cache.selectedStore;
                                            if(isAuthenticated) selectedStoreId = fp.user.selected_store_id || fp.getPrefCookie().store_id;
                                            else selectedStoreId = fp.getSelectedStoreId();

                                            fpService.storeService
                                                .get({
                                                    id: fp.session.store_id + (selectedStoreId ? ',' + selectedStoreId : '')
                                                })
                                                .then(function(resp) {
                                                    //if possible combine top store API call with selected store API call
                                                    _.each(resp.items, function(item) {
                                                        if(item.id === fp.session.store_id) fp.topStore = item;
                                                        else if(selectedStoreId && item.id === selectedStoreId) fp.cache.selectedStore = item;
                                                    });
                                                    
                                                    if(fp.topStore.other_attributes?.top_shopping_store_id) {
                                                        fpConfig.topShopStoreId = fp.topStore.other_attributes.top_shopping_store_id;
                                                    }
                                                })
                                                .then(function() {
                                                    if(initializeShopping) {
                                                        return fpUtil.map.load({
                                                            service: fpService.tagService,
                                                            payload: {
                                                                type: 'store_price_mode,product_status,offer_status,sale_configuration_type,fulfillment_type',
                                                                store_id: fp.topStore.id
                                                            }
                                                        });
                                                    }
                                                })
                                                .always(function() {
                                                    promiseBodyReady
                                                        .then(function() {
                                                            if(initializeShopping && urlParams.store_number) return fp.getStore();
                                                        })
                                                        .done(function() {
                                                            var storeId = null,
                                                                storeNumber,
                                                                kioskStoreId;

                                                            if(initializeShopping) {
                                                                storeId = urlParams.store || urlParams.store_id || $('[data-requiredStoreId]').attr('data-requiredStoreId') || fpConfig.shoppingStoreId;
                                                                storeNumber = urlParams.store_number;
                                                                kioskStoreId = urlParams.kiosk_store_id;
                                                            }

                                                            //preInitModules needs to be called before we can call ensureActiveStore
                                                            fp.ensureActiveStore(false, {
                                                                    storeId: storeId,
                                                                    storeNumber: storeNumber,
                                                                    kioskStoreId: kioskStoreId
                                                                })
                                                                .then(function() {
                                                                    var pref = fp.getPrefCookie();

                                                                    if(!pref.has_client_location) {
                                                                        const storeRequiredOptions = _.getObject(fpConfig.storeRequiredOptions);
                                                                        let currentStoreId = fp.store.id || storeId || pref.store_id;

                                                                        if((fp.config.auto_store_select || storeRequiredOptions.enableSetStoreByLocation) &&
                                                                            !isAuthenticated &&
                                                                            !(storeId || storeNumber) && //don't set if store is being set from URL
                                                                            (!currentStoreId)
                                                                        ) {
                                                                            if(fp.config.auto_store_select) {
                                                                                if(!pref.has_client_ip_location) {
                                                                                    $.ajax({
                                                                                        url: "https://pro.ip-api.com/json?key=NkUDdeAIlEZHeay&fields=lat,lon",
                                                                                        method: "get",
                                                                                        dataType: 'json'
                                                                                    })
                                                                                    .done(function(resp){
                                                                                        return fpUtil.getClosestStore(true, {latitude: resp.lat, longitude: resp.lon}, true);
                                                                                    });
                                                                                }
                                                                            }
                                                                            else {
                                                                                return fpUtil.selectStoreByClientLocation();
                                                                            }
                                                                        }
                                                                    }
                                                                })
                                                                .always(function() {
                                                                    var promiseStore,
                                                                        promiseSingleStore;

                                                                    if(!fp.store.id) {
                                                                        promiseStore = fp.getStore(storeId, storeNumber);
                                                                    }

                                                                    if(initializeShopping) {
                                                                        promiseSingleStore = fpService.storeService
                                                                            .get({
                                                                                is_selectable: true,
                                                                                has_address: true,
                                                                                limit: 1
                                                                            })
                                                                            .done(function (resp) {
                                                                                fp.singleStore = _.first(resp.items);
                                                                                fp.isSingleStore = fpUtil.getInteger(resp.total) <= 1;
                                                                            });
                                                                    }

                                                                    $.when(
                                                                        promiseStore,
                                                                        promiseSingleStore
                                                                    )
                                                                    .always(function() {
                                                                        //if no store is selected store change event will
                                                                        //be triggered after module load
                                                                        if(fp.store.id) fp.trigger(fp.events.STORE_CHANGED, fp.store);

                                                                        deferredEnsureActiveStore.resolve();

                                                                        fp.ui.loadStoreDependencies()
                                                                            .always(function() {
                                                                                fpUtil.showProgress(0.2);
                                                                                deferredStoreDependencies.resolve();
                                                                                if(fp.__promiseStoreDependencies) fp.__promiseStoreDependencies.deferred().resolve();
                                                                            });

                                                                        if(initializeShopping) {
                                                                            if(fp.listManager.getList().id === fp.defaultList.id) {
                                                                                fp.listManager.getSelectedList(true, null, {handleErrors: false})
                                                                                    .always(function () {
                                                                                        fpUtil.showProgress(0.2);
                                                                                        deferredList.resolve();
                                                                                    });
                                                                                }
                                                                            else {
                                                                                fp.listManager.setEnableCheckout();
                                                                                deferredList.resolve();
                                                                            }
                                                                        }
                                                                        else {
                                                                            deferredList.resolve();
                                                                        }
                                                                    });
                                                                });
                                                        });
                                                });
                                        })
                                        .fail(function() {
                                            if(fp.isUnloading) return;

                                            delete fp.__oldStoreId;
                                            fp.loaded = true;

                                            fpUtil.hideLoading(true);
                                            fpUtil.hideProgress(true);

                                            fp.ui.unblockUI();
                                            fp.__$freshop.removeClass('fp-freshop-loading');
                                            //fp.ui.postMetric(loadStartDate);
                                        });

                                    if(fp.isUnloading) {
                                        return;
                                    }

                                    var promiseInitDepartments = $.when(
                                            deferredStoreDependencies,
                                            deferredList
                                        )
                                        .then(function() {
                                            if(fp.isUnloading) return;

                                            fpUtil.initDepartment(urlParams.department_id);

                                            //removeIf(!debug)

                                            // var delay = fpUtil.getInteger(urlParams.module_load_hang_for);
                                            // if(delay) {
                                            //     fp.warn(fpUtil.formatString('Delaying module load for {0}ms', delay));
                                            //     return fpUtil.delayPromise(null, delay);
                                            // }

                                            //endRemoveIf(!debug)
                                        });

                                    return $.when(promiseSession, promiseInitDepartments);
                                });

                            promiseBodyReady
                                .done(function() {
                                    if(fpConfig.enableImageOptimization) {
                                        var img = new Image();
                                        img.onerror = img.onload = function (event) {
                                            fp.hasWebp = event && event.type === 'load' ? img.width === 1 : false;
                                        };
                                        img.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
                                    }

                                    fpUi.initBodyEvents();

                                    //fp.log('fp.ui.preInitModules')
                                    fp.ui.preInitModules();

                                    promiseComponents
                                        .always(function() {
                                            if(
                                                fp.isUnloading ||
                                                fp.documentReady
                                            ) {
                                                return;
                                            }

                                            fp.documentReady = true;

                                            fp.__$freshop = $(fp.ui.renderTemplate('component/0/freshop.html', null, null, true)).appendTo(document.body);

                                            var hasTouch = fp.device.hasTouch,
                                                $body = $(document.body)
                                                    .attr('data-theme', S(fpConfig.theme).getString('theme-0').trimLeft('fp-').s);

                                            if (hasTouch) $body.addClass('fp-touch');
                                            else $body.addClass('fp-notouch');

                                            fpUi.processStyleSheets();

                                            if(fp.apiErrorQueue.length) {
                                                var obj = fp.apiErrorQueue[0];
                                                fpUtil.handleApiError(obj.resp, obj.textStatus, obj.jqXHR, obj.options);
                                                fp.apiErrorQueue.length = 0;
                                            }
                                            else {
                                                //initialize view module loader
                                                fp.ui.blockUI();

                                                //initialize other loaders
                                                fp.loader = new fpUi.Loading(fp.ui.renderTemplate('component/0/loading.html', null, null, true));
                                                fp.formLoader = new fpUi.Loading();

                                                fpUtil.showProgress();
                                            }

                                            if(fpConfig.enableLoadEarlyModules && routeManager.urlParams.disable_early_modules != 'true') {
                                                deferredEnsureActiveStore
                                                    .then(function () {
                                                        fp.log('loadEarlyModules');

                                                        var earlyModules = {},
                                                            moduleConfig;
                                                        _.each(fp.earlyModules, function (key) {
                                                            moduleConfig = fpConfig.modules[key];
                                                            if (!moduleConfig) return;

                                                            earlyModules[key] = moduleConfig;
                                                        });

                                                        return fpUi.loadModules(earlyModules);
                                                    })
                                                    .done(function () {
                                                        fp.log('renderEarlyModules');
                                                    })
                                                    .always(deferredLoadEarlyModules.resolve);
                                            }
                                            else deferredLoadEarlyModules.resolve();

                                            fp.trigger(fp.events.DOCUMENT_READY);
                                        });

                                    $.when(promiseInitUI, deferredLoadEarlyModules)
                                        .always(function() {
                                            initModals();

                                            var promiseRouteIntent,
                                                promiseLoadModules;

                                            if(routeManager.urlParams.action == 'add-to-list') {
                                                promiseRouteIntent = fpUi.processRouteIntent();
                                            }

                                            //removeIf(!debug)

                                            //if(routeManager.urlParams.enable_frontload_modules == 'true') {
                                            //    promiseLoadModules = [];
                                            //
                                            //    var modulePath,
                                            //        layout;
                                            //
                                            //    _.each(fpConfig.modules, function(items, key) {
                                            //        items = _.isArray(items) ? items : [items];
                                            //
                                            //        _.each(items, function(moduleConfig) {
                                            //            if (!moduleConfig.authorized) return;
                                            //
                                            //            layout = S.getString(moduleConfig.layout, 'layout-0');
                                            //
                                            //            modulePath = moduleConfig.name.split('/');
                                            //            if (modulePath.length == 1) modulePath.push(modulePath[0]);
                                            //            modulePath.unshift('module');
                                            //            modulePath.splice(modulePath.length - 1, 0, layout.replace('-', '/'));
                                            //            modulePath[modulePath.length - 1] = modulePath[modulePath.length - 1] + '.json';
                                            //
                                            //            fp.log(modulePath.join('/'));
                                            //            promiseLoadModules.push(fp.api(modulePath.join('/'), null, {
                                            //                cache: true,
                                            //                apiKey: 'sdk'
                                            //            }));
                                            //        });
                                            //    });
                                            //
                                            //    promiseLoadModules = $.when.apply($, promiseLoadModules);
                                            //
                                            //    //promiseLoadModules = fp.api('module/module.json', null, {apiKey: 'sdk'})
                                            //    //    .then(function(resp) {
                                            //    //        fp.cache.module = resp;
                                            //    //    });
                                            //}

                                            //endRemoveIf(!debug)

                                            $.when(promiseRouteIntent)
                                                //.then(function() {
                                                //    return promiseLoadModules;
                                                //})
                                                .then(function() {
                                                    return fpUi.loadModules(fpConfig.modules, null, true);
                                                })
                                                .always(function(resp) {
                                                    if(fp.isUnloading) return;

                                                    var timeoutId,
                                                        progressHidden = false;
                                                    (function hideProgress(force) {
                                                        //force progress bar to hide 3s after freshop is loaded
                                                        //(covers case where some promises do not get resolved)
                                                        if(!timeoutId) timeoutId = _.delay(hideProgress, 3000, true);

                                                        fpUtil.hideProgress(force)
                                                            .always(function() {
                                                                if(progressHidden) return;
                                                                progressHidden = true;

                                                                if(force) fp.log('Forced hiding of progress bar after 3s');

                                                                $.when(resp?.disableProgressPromise)
                                                                    .always(function() {
                                                                        if(fp.isUnloading) return;

                                                                        //window error case will set fp.loaded to ensure errors are displayed
                                                                        //set fp.loaded to false here so that we don't duplicate certain calls
                                                                        if(fp.loaded) fp.loaded = false;

                                                                        fpUi.unblockUI({force: true});
                                                                        fp.__$freshop.removeClass('fp-freshop-loading');
                                                                        
                                                                        if(!fp.store.id || S(fp.store.id).ne(fp.__oldStoreId)) {
                                                                            fp.trigger(fp.events.STORE_CHANGED, (fp.store.id ? fp.store : {}));
                                                                        }

                                                                        delete fp.__oldStoreId;

                                                                        fp.loaded = true;
                                                                        freshop.loaded = true;

                                                                        //clean load remove reload flag
                                                                        //if(_.has(stateManager.stateParams, 'reload')) {
                                                                        //    stateManager.go(stateManager.current, {reload: null}, {
                                                                        //        preventDefault: true,
                                                                        //        inherit: true
                                                                        //    });
                                                                        //}

                                                                        var now = new Date(),
                                                                            duration = fp.numeralInstance.set(dateFns.differenceInMilliseconds(now, fp.loadStartDate) / 1000).format('#,0.0##'),
                                                                            viewModuleDuration = fp.viewModuleRenderTime ? fp.numeralInstance.set(dateFns.differenceInMilliseconds(fp.viewModuleRenderTime, fp.loadStartDate) / 1000).format('#,0.0##') : null,
                                                                            apiTotalDuration = fp.numeralInstance.set(dateFns.differenceInMilliseconds(fp.apiTotalEndDate, fp.apiTotalStartDate) / 1000).format('#,0.0##'),
                                                                            apiSumDuration = fp.numeralInstance.set(fp.apiSumDuration / 1000).format('#,0.0##');

                                                                        fpUi.postMetric(duration, apiTotalDuration, apiSumDuration, fp.apiCallTotalCount, viewModuleDuration);

                                                                        fp.log('Freshop loaded');
                                                                        fp.trigger(fp.events.LOADED);

                                                                        if(fpUi.router.routeManager.urlParams.action == 'addToCart') {
                                                                            fpUi.processRouteIntent();
                                                                        }

                                                                        //if(fp.isLocal()) {
                                                                        //    fpUi.showShopIntentModal(true);
                                                                        //}
                                                                    });
                                                            });
                                                    })();
                                                });
                                        });
                                });
                        });
                    });
        }
        ,refreshUser: function() {
            return fpService.userMeService.get()
                .then($.proxy(this.setUser, this));
        }
        //return a bool siginifying if the selected store has a fulfillment type
        ,hasStoreFulfillment: function(store) {
            return _.size((store || this.store).fulfillment_types) > 0;
        }
        ,getStoreFulfillmentTypes: function() {
            let items = fpUtil.map.get('storeFulfillmentType', null, true).items();
            if(!items.length) items = fpUtil.map.get('fulfillmentType').items();
            return items;
        }
        ,getDefaultStoreFulfillmentType: function(payload, options) {
            // return _.findWhere(this.store.fulfillment_types, {identifier: 'delivery'});
            var list = fp.listManager.getList(),
                quantity = fp.ui.ListManager.getListQuantity(list),
                promise;

            if(fp.store.id && quantity > 0) {
                payload = $.extend({
                    type: 'fulfillment_type',
                    store_id: fp.store.id,
                    shopping_list_id: list.id
                }, payload);

                promise = fpService.tagService.get(payload, options);
            }

            return $.when(promise)
                .then(function(resp) {
                    var items = (resp && resp.items) || fp.getStoreFulfillmentTypes(),
                        item;

                    if(options.preferred) {
                        item = _.find(items, function(item) {
                            return item.id == options.preferred;
                        });
                    }
                    return item || _.first(items);
                });
        }
        ,clearOrderPreference: function(preferenceData, errorCode, errorMessage) {
            //if(fp.isLocal()) {
            //    return $.Deferred().resolve(this.preference).then(function () {
            //        fp.trigger(fp.events.ORDER_CLEARED, {errorCode: errorCode, errorMessage: errorMessage});
            //    });
            //}

            Lockr.rm('order');

            var preference = $.extend({}, fp.session.preference),
                oldPreference = $.extend({}, preference),
                promise;

            _.each([
                'order_step',
                'order_id',
                'order_store_id',
                'order_fulfillment_type_id',
                'order_show_submit',
                'payment_method',
                'saved_payment_method',
                'payment_type_id'
            ], function(key) {
                delete preference[key];
            });

            if (_.isObject(preferenceData)) $.extend(preference, preferenceData);

            if (_.isEqual(oldPreference, preference)) {
                promise = $.Deferred().resolve(preference).promise();
            }
            else {
                promise = fpService.preferenceService.update(preference, null, {replace: true, session: true});

                if (errorCode || errorMessage) {
                    fp.notifier.notify({
                        name: 'clearOrderPreference',
                        message: 'clearOrderPreference: clearing order preference'
                    }, {
                        severity: 'warning',
                        metaData: {
                            'meta data': {
                                errorCode: errorCode,
                                errorMessage: errorMessage
                            }
                        }
                    });
                }
            }

            return promise
                .then(function() {
                    //until all in-progress orders are cleared we need to also clear session the old way
                    if(_.hasAny(fp.session, [
                            'order_step',
                            'order_id',
                            'order_store_id',
                            'order_fulfillment_type_id',
                            'payment_method',
                            'saved_payment_method',
                            'payment_type_id'
                        ])) {
                        return fpService.sessionService
                            .post({
                                id: fp.session.token,
                                payload: null
                            }, {apiVersion: 1})
                            .done(function(resp) {
                                fp.setSession(resp, true);
                            });
                    }
                })
                .done(function() {
                    fp.trigger(fp.events.ORDER_CLEARED, {errorCode: errorCode, errorMessage: errorMessage});
                });
        }
        ,storeChange: function(options) {
            //fp.log('storeChange', options);
            options = _.getObject(options);
            const callback = _.getFunction(options.callback);
            if(!(options.storeId || options.storeNumber)) {
                callback(fp.store);
                return $.when();
            }

            var quantity = fp.ui.ListManager.getListQuantity(),
                currentStoreId = options.currentStoreId || fp.store.id || fp.getSelectedStoreId(),
                $modal;

            if(!options.storeId && options.storeNumber && fp.store.number == options.storeNumber) {
                options.storeId = fp.store.id;
                delete options.storeNumber;
            }

            //don't show modal if there is no currently selected store
            //OR disableStoreChangeConfirmation is set
            //OR there is nothing in list and -- client disabled store change confirmation OR Freshop UI is already loaded
            if(!currentStoreId || options.disableStoreChangeConfirmation || (!quantity && (fpConfig.disableStoreChangeConfirmation || fp.loaded))) {
                return fp.getStore(options.storeId, options.storeNumber)
                    .done(setStoreDone);
            }

            function setStoreDone() {
                callback(fp.store);
                fp.trigger(fp.events.STORE_AFTER_CHANGE);

                var next = _.result(options, 'next');
                if(next) {
                    if(!options.allowAllUrls) next = fpUi.router.routeManager.relativeUrl(next);
                    fpUi.router.stateManager.go(next, null, {absolute: true});
                }
            }

            function setSelectedStore(answer) {
                var storeId;

                if(!answer) storeId = currentStoreId;
                else if (options.storeId != '0') storeId = options.storeId;

                //user chose to keep current store instead of switching to user.selected_store_id
                var activeStoreId = null;
                if(options.hasSelectedStoreChanged && S(storeId).ne(fp.user.selected_store_id)) {
                    fp.setPrefCookie({store_id: storeId});
                    activeStoreId = storeId;
                }
                fp.setSessionCookie({active_store_id: activeStoreId});

                fp.getStore(storeId)
                    .always(setStoreDone);
            }

            function initModal() {
                return $.when($.ready)
                    .then(function() {
                        var deferred = $.Deferred();
                        $modal = fp.__$freshop.find('[data-role="modal-container"] .fp-store-confirm-modal');
                        if (!$modal.length) {
                            $modal = $('\
                                    <div class="modal fp-store-confirm-modal fade" tabindex="-1" role="dialog" aria-modal="true"> \
                                        <div class="modal-dialog"> \
                                            <div class="modal-content"> \
                                                <div class="modal-header fp-heading"> \
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="close modal"><span aria-hidden="true">&times;</span></button> \
                                                    <h3 aria-level="1"><span>' + fp.ui.localef('shared-store-update-confirmation', '{0} Update Confirmation', fp.config.storeTitle) + '</span></h3> \
                                                </div> \
                                                <div class="modal-body clearfix"> \
                                                    <div class="fp-modal-content fp-margin-bottom">' + fp.ui.renderTemplate('component/0/animated-loading.html') + '</div> \
                                                    <a href="javascript:;" class="fp-btn fp-btn-close fp-btn-save pull-right">' + fp.ui.locale('shared-yes', 'Yes') + '</a> \
                                                    <a href="javascript:;" class="fp-btn fp-btn-secondary fp-btn-close fp-margin-right pull-right">' + fp.ui.locale('shared-no', 'No') + '</a> \
                                                </div> \
                                            </div> \
                                        </div> \
                                    </div> \
                                ')
                                .modal({
                                    show: true,
                                    backdrop: 'static',
                                    disableClose: true
                                });
                        }
                        else $modal.modal('show');

                        $modal.one('shown.bs.modal.storeConfirm', deferred.resolve);

                        return deferred.promise();
                    });
            }

            if(
                (currentStoreId && currentStoreId != options.storeId) ||
                (options.storeNumber && options.storeNumber != fp.store.store_number)
            ) {
                if(options.disableConfirmation && (options.storeId != '0' || options.storeNumber)) {
                    setSelectedStore(true);
                    return;
                }

                var promiseInitModal,
                    store;

                if(!options.loadStoreFirst) {
                    promiseInitModal = initModal();
                }

                $.when(promiseInitModal)
                    .then(function() {
                        if(options.storeId != '0' || options.storeNumber) {
                            var payload = {};

                            if(options.storeId) payload.id = options.storeId;
                            else payload.number = options.storeNumber;

                            const selectedStore = fp.cache.selectedStore;
                            delete fp.cache.selectedStore;
                            if(selectedStore && (payload.id === selectedStore.id || payload.number === selectedStore.number)) {
                                store = selectedStore;
                            }
                            else {
                                return fpService.storeService
                                    .get(payload, {handleErrors: false})
                                    .done(function(resp) {
                                        store = _.first(resp.items);
                                    });
                            }
                        }
                    })
                    .always(function() {
                        store = _.getObject(store);

                        if(!store.is_selectable) {
                            if($modal) $modal.modal('hide');

                            setStoreDone();

                            return;
                        }

                        var promise;
                        if(!$modal) promise = initModal();

                        $.when(promise)
                            .always(function(){
                                if(store.number == options.storeNumber) {
                                    delete options.storeNumber;
                                    options.storeId = store.id;
                                }

                                var content;

                                if(options.storeId == '0') {
                                    content = ' \
                                        <p>Continuing will remove your selected ' + fp.config.storeTitle +  '.</p> \
                                        <p>Are you sure you want to continue?</p> \
                                    ';
                                }
                                else {
                                    content = _.isFunction(options.content) ? options.content() : options.content;

                                    if(!content) {

                                        const customMsg = fpConfig.customStoreUpdateMsg?.datasets, 
                                              availability = _.findWhere(customMsg, {identifier: 'availability'})?.text || fp.ui.locale('ui-availability', 'Product availability is different at each store so some items may not be in stock at the store you are selecting.'),
                                              checkList = _.findWhere(customMsg, {identifier: 'check_list'})?.text || fp.ui.locale('ui-check-list', 'Please check your Full List after changing stores for any items that may be unavailable at the new store.'),
                                              switchBack = _.findWhere(customMsg, {identifier: 'switch_back'})?.text || fp.ui.locale('ui-switch-back', 'If you switch back to a store that carries an item it will be re-added to your list.'),
                                              orderProgress = _.findWhere(customMsg, {identifier: 'order_progress'})?.text || fp.ui.locale('ui-order-progress', 'You have an order that is in progress. If you update your store your order will be canceled and you will need to start the checkout process again.');

                                        var userStoreChange = (options.hasSelectedStoreChanged ? fp.ui.renderTemplate('component/0/user-store-change.html') : null) || '',
                                            orderStoreChange = (fp.session.preference.order_store_id && S(fp.session.preference.order_store_id).ne(store.id) ? fp.ui.renderTemplate('component/0/order-store-change.html', {
                                                orderProgress: orderProgress
                                            }) : null) || '',
                                            storeChangeProduct = (quantity > 0 || orderStoreChange ? fp.ui.renderTemplate('component/0/store-change-products.html', {
                                                availability: availability,
                                                checkList: checkList,
                                                switchBack: switchBack
                                            }) : null) || '';

                                        content = fp.ui.renderTemplate('component/0/store-change.html', {
                                            userStoreChange: userStoreChange,
                                            orderStoreChange: orderStoreChange,
                                            storeChangeProduct: storeChangeProduct,
                                            storeName: store.name
                                        });
                                    }
                                }

                                var answer = false;
                                $modal
                                    .off('click.confirmModal hidden.bs.modal.confirmModal')
                                    .on('click.confirmModal', '.fp-btn-close', function (event) {
                                        answer = $(this).hasClass('fp-btn-save');
                                        $modal.modal('hide');
                                    })
                                    .on('hidden.bs.modal.confirmModal', function (event) {
                                        if(_.isFunction(fpConfig.storeChangeConfirm)) {
                                            fpConfig.storeChangeConfirm(answer, store, fp.store);
                                        }
                                        if(!fp.isUnloading) setSelectedStore(answer);
                                    });

                                $modal.find('.modal-body .fp-modal-content')
                                    .css('height', 'auto').html(content);
                            });
                    });
            }
            else {
                setSelectedStore();
            }
        }
        ,hasSelectedStoreChanged: function() {
            if(!fpUtil.isAuthenticated()) return false;

            return (
                !fp.getSessionCookie().active_store_id &&
                S(fp.getPrefCookie().store_id).ne(fp.user.selected_store_id)
            );
        }
        ,ensureActiveStore: function(loginInit, options) {
            if(fpConfig.disableInitializeShopping) return $.when();

            options = _.getObject(options);

            if(fp.config.enableKiosk && options.kioskStoreId) {
                fp.setPrefCookie({kiosk_store_id: options.kioskStoreId});
            }
            
            var deferred = $.Deferred(),
                pref = fp.getPrefCookie(),
                currentStoreId,
                userSelectedStoreId,
                callback,
                hasSelectedStoreChanged,
                disableStoreChangeConfirmation;

            if(fpConfig.enableRequiredStore) {
                if(!fp.disableRequiredStore) {
                    delete options.storeId;
                    delete options.storeNumber;

                    callback = function () {
                        if(fp.requiredStoreId && S(fp.store.id).ne(fp.requiredStoreId)) {
                            //user chose to keep current store instead of switching to module's required store
                            //which means the user cannot access this page, redirect to shop page
                            var redirectTo;
                            if(_.isObject(fpConfig.requiredStoreUrls)) {
                                redirectTo = fpConfig.requiredStoreUrls[fp.store.id];
                            }

                            fp.ui.router.stateManager.go(redirectTo || fp.ui.router.stateManager.href(fpConfig.routeStates.product), null, {absolute: true});

                            return;
                        }

                        if (!fp.store.id || S(fp.store.id).eq(userSelectedStoreId)) {
                            deferred.resolve();
                            return;
                        }

                        fp.clearOrderPreference()
                            .done(deferred.resolve);
                    };

                    userSelectedStoreId = fp.getSelectedStoreId();

                    currentStoreId = S.getString(fp.user.selected_store_id, userSelectedStoreId);

                    if (fp.requiredStoreId) {
                        var payload = {store_id: fp.requiredStoreId};
                        if (!pref.default_store_id) {
                            payload.default_store_id = fpUtil.getNullIfEmpty(pref.store_id);
                        }

                        fp.setPrefCookie(payload);

                        userSelectedStoreId = fp.getSelectedStoreId();
                    }
                    else {
                        //silently switch user's store back to default store
                        //fp.setPrefCookie({
                        //    store_id: pref.default_store_id || fpConfig.requiredStoreId,
                        //    default_store_id: null
                        //});

                        callback();

                        return deferred.promise();
                    }
                }
            }
            else {
                hasSelectedStoreChanged = (!loginInit && fp.hasSelectedStoreChanged());

                if (hasSelectedStoreChanged) {
                    disableStoreChangeConfirmation = pref.has_default_store;
                    fp.setPrefCookie({has_default_store: null});

                    currentStoreId = pref.store_id;
                    userSelectedStoreId = fp.user.selected_store_id;

                    callback = function () {
                        if (S(fp.store.id).ne(userSelectedStoreId)) {
                            //user chose to keep current store instead of switching to user's selected_store_id
                            deferred.resolve().promise();
                            return;
                        }

                        fp.clearOrderPreference()
                            .done(deferred.resolve);
                    };
                }
                else if (
                    fpUtil.isAuthenticated() &&
                    pref.store_id &&
                    S(fp.getSessionCookie().active_store_id).ne(pref.store_id) &&
                    S(fp.user.selected_store_id).ne(pref.store_id)
                ) {
                    currentStoreId = fp.user.selected_store_id;
                    userSelectedStoreId = pref.store_id;
                    callback = deferred.resolve;
                }
                else if(_.size(options)) {
                    currentStoreId = fp.getSelectedStoreId();
                    callback = deferred.resolve;
                }
                else {
                    return deferred.resolve().promise();
                }
            }

            var storeId = options.storeId || fpUtil.getStateValue(fp.config.enableKiosk && !pref.store_id, pref.kiosk_store_id) || fpUtil.getStateValue(!options.storeNumber && !fp.config.disableUserChangedStore, userSelectedStoreId),
                storeNumber = options.storeNumber;

            //if freshop is loaded, short circuit store change logic
            if(fp.loaded && !loginInit && !storeNumber && S(storeId).eq(currentStoreId)) {
                return deferred.resolve().promise();
            }

            if(!fp.loaded) {
                fp.__oldStoreId = currentStoreId;
            }

            var promiseList;
            if(currentStoreId && fp.listManager.getList().id == '0') {
                //we need to check list quantity for selected store
                promiseList = fp.listManager.refreshList(true, {store_id: currentStoreId}, {handleErrors: false});
            }

            $.when(promiseList)
                .always(function() {
                    fp.storeChange({
                        currentStoreId: currentStoreId,
                        storeId: storeId,
                        storeNumber: storeNumber,
                        hasSelectedStoreChanged: hasSelectedStoreChanged,
                        disableStoreChangeConfirmation: disableStoreChangeConfirmation,
                        loadStoreFirst: true,
                        callback: callback
                    });
                });

            return deferred
                .promise();
        }

        ,handleSignInRequired: function(errorMessage) {
            var routeStates = fpConfig.routeStates,
                uiRouter = fpUi.router,
                stateManager = uiRouter.stateManager,
                initializeShopping = !(fpConfig.disableInitializeShopping);

            if(fpConfig.guestCheckOut.enabled) {
                stateManager.go('/', null, {absolute: true});
            }
            else {
                var loginState = stateManager.get(routeStates.login.name) || stateManager.get(routeStates.admin.name),
                    next = initializeShopping ? uiRouter.location.pathname(true) : null;

                fp.logout(stateManager.href(loginState, {error: errorMessage, next: next}));
            }

            //don't resolve/reject the promise for these failures yet (until code can support the redirect that occurs properly)
            return $.Deferred().promise();
        }
        ,handleSignOutRequired: function(errorMessage, disableSessionInitialize, status, apiUrl) {
            //ensure that session has values
            //if not, we may already be in the process of clearing session token
            if (fp.getSessionCookie().token || fp.session.token) {
                var uiRouter = fpUi.router,
                    stateManager = uiRouter.stateManager;

                // if(fpConfig.guestCheckOut.enabled) {
                //     stateManager.go('/', null, {absolute: true});
                // }
                // else {
                    var urlParams = {token: null},
                        next = uiRouter.routeManager.buildUrl(uiRouter.location.pathname(true), {
                            inherit: true,
                            searchParams: urlParams,
                            routeSearchParams: urlParams
                        });

                    if (fpUtil.getValueFromNamespace('data.authenticate', stateManager.current)) {
                        var routeStates = fpConfig.routeStates;

                        next = stateManager.href(stateManager.get(routeStates.login) || stateManager.get(routeStates.admin), {
                            error: errorMessage,
                            next: next
                        });
                    }

                    if (disableSessionInitialize) fp.sessionInitialized = false;

                    fp.logout(next);
                // }
            }

            //don't resolve/reject the promise for these failures yet (until code can support the redirect that occurs properly)
            return $.Deferred().promise();
        }
        ,registerRouteStates: function(routeStates) {
            routeStates = routeStates || fpConfig.routeStates;
            //initialize urls/routes
            //if(!S(window.location.hash).startsWith(fp.routeDelimiter)) {
            //    fp.routeDelimiter = '#';
            //}

            const stateManager = fpUi.router.stateManager,
                path = fpUi.router.location.pathname(),
                urls = fpConfig.urls;

            //match url ending slash
            if(path != '/') fpConfig.urlTrailingSlash = S(path).endsWith('/');
            _.each(urls, function(value, key) {
                urls[key] = S(value).trailingSlashIt().s;
            });

            if(urls.checkoutConfirmation) {
                routeStates.checkoutConfirmation.url = '{{checkoutConfirmation}}';
                delete routeStates.checkoutConfirmation.parent;
            }
            if(!urls.login) urls.login = S(urls.account).ensureRight('/').s + 'login';

            //routeStates.myCoupon.data.title = fpConfig.myCouponTitle;

            //set up state urls before state initialization
            const baseUrl = '/{0}' + S().trailingSlashIt().s + fp.routeDelimiter + '/',
                states = {},
                matchRoute = fpUtil.regExp.matchRoute,
                hashedStates = _.indexBy(routeStates, 'name');

            let urlMatches,
                prop,
                propKey,
                parentState,
                parentStateUrl,
                excludeState,
                value;

            _.each(routeStates, function(state, key) {
                if (fpConfig.disableInitializeShopping) {
                    excludeState = state;
                    while (excludeState.parent && excludeState.name != excludeState.parent) {
                        if (excludeState.isShoppingExclusive) break;
                        excludeState = hashedStates[excludeState.parent];
                    }
                    if (excludeState && excludeState.isShoppingExclusive) return;
                }

                urlMatches = S.getString(state.url).match(matchRoute);

                if(urlMatches) {
                    propKey = urlMatches[1];
                    prop = urlMatches[2];

                    if (propKey) {
                        value = urls[prop];
                        if (!value || !(_.isString(value) && value.length)) return;
                        value = S(value).trim('/').s;
                        state.url = state.url.replace(propKey, fpUtil.formatString(baseUrl, value));
                    }
                }

                if((!state.parent || state.disableConcat) && fpConfig.enableLocaleRoute) {
                    state.url = '/{lang:[a-z]{2,2}-[a-z]{2,4}}' + state.url;
                    state.params = $.extend(state.params, {
                        lang: {
                            squash: true,
                            raw: true,
                            inherit: true
                        }
                    });
                }

                parentState = state.parent ? hashedStates[state.parent] : null;
                if(parentState) {
                    parentStateUrl = S.getString(parentState.url).split('?')[0];
                    let url = S(state.url);
                    if(!url.startsWith(parentStateUrl + '-')) url = url.trimLeft(parentStateUrl);
                    //if(!S(state.url).startsWith('/:')) state.url = S(state.url).trimLeft('/').s;
                    if(!parentState.parent && !state.disableConcat) url = url.trimLeft('/');
                    state.url = url.s;
                }

                //controller = S(state.controller);
                //params = '';
                //if(controller.endsWith('-edit')) {
                //
                //}
                //else if(controller.endsWith('-list')) {
                //    _.each($.extend({page: 1}, fpUtil.urlParams(state.url)), function(value, key) {
                //        if(params) params += '&';
                //        params += key;
                //    });
                //}
                //if(params) state.url = S.getString(state.url.split('?')[0]) + '?' + params;

                if(state.data && state.data.authorize) state.data.authenticate = true;
                states[key] = state;
            });

            if(fpConfig.enableLocaleRoute) {
                stateManager.rootStateConfig.url = '/{lang:[a-z]{2,2}-[a-z]{2,4}}{route:path}';
                stateManager.rootStateConfig.params = {
                    lang: {
                        squash: true,
                        raw: true,
                        inherit: true
                    },
                    route: {
                        squash: true,
                        raw: true
                    }
                };
            }

            stateManager.register(states);
        }
        ,initProductsModal: function(persist) {
            //products modal
            var $activeModal,
                $productsModal = $(fpUi.renderTemplate('component/0/modal-products.html', null, null, true))
                    .modal({
                        show: false,
                        persist: persist
                    })
                    .on('show.bs.modal.products', function() {
                        $activeModal = fp.__$freshop.find('[data-role="modal-container"] .modal.in');

                        if ($activeModal.length && $activeModal[0] != $productsModal[0]) {
                            $productsModal.removeClass('fade in');
                            $activeModal
                                .hide()
                                .attr('aria-hidden', 'true')
                                .prev('.modal-backdrop').hide();
                        }
                        else $activeModal = null;
                    })
                    .on('shown.bs.modal.products', function() {
                        fp.one(fpUtil.formatString('{0}.bs.modal.products', fp.events.ROUTE_CHANGED), function() {
                            fp.ui.hideModal($productsModal);
                        });
                        
                        // for ada, better to remove aria-hidden when modal is display
                        fp.__$freshop.find('[data-role="modal-container"] .modal.in')?.removeAttr('aria-hidden');

                        // $(this)
                        //     .find('.modal-body')
                        //     .find('input[type="search"]:visible, input[type="text"]:visible, textarea:visible').first().focus();
                    })
                    .on('hide.bs.modal.products', function () {
                        if($activeModal) {
                            $activeModal
                                .show()
                                .removeAttr('aria-hidden')
                                .prev('.modal-backdrop').show();
                        }
                    })
                    .on('hidden.bs.modal.products', function() {
                        if($activeModal) {
                            // fp.__$freshop.addClass('modal-open');
                            $activeModal.closest('[data-role="modal-container"]').addClass('modal-open');
                            $activeModal = null;
                        }

                        fp.off(fpUtil.formatString('{0}.bs.modal.products', fp.events.ROUTE_CHANGED));
                    });

            function initShowProductsModal(options) {
                var $modal = options.$modal,
                    bsModal = _.getObject($modal.data('bs.modal')),
                    productIds = _.getArray(options.productIds),
                    productUpcs = _.getArray(options.productUpcs),
                    notFound = [],
                    $body = $modal.find('.modal-body > .fp-modal-content'),
                    item,
                    cache = fp.cache.product,
                    title;

                if(productIds.length) {
                    _.each(productIds, function(key) {
                        item = cache.items[key];
                        if(!item) notFound.push(key);
                    });
                    title = cache.items[productIds[0]] ? cache.items[productIds[0]].name : null;
                }

                if(productUpcs.length) {
                    _.each(productUpcs, function(key) {
                        item = cache.items[key];
                        if(!item) notFound.push(key);
                    });
                    title = cache.items[productUpcs[0]] ? cache.items[productUpcs[0]].name : null;
                }
                options.title = options.title || title || fp.ui.locale('shared-products', 'Products');

                var $header = $modal.find('.modal-header'),
                    $subTitle = $header.find('h5').addClass('hidden');
                $header.find('h3 span').html(options.title);
                if(options.subTitle) $subTitle.removeClass('hidden').find('span').html(options.subTitle);

                var $intro = $body.parent().find('> .fp-modal-intro').empty();
                if(options.introContent) {
                    $intro.append(options.introContent);
                    $intro.append('<hr class="fp-margin-caps" />');
                }

                if(fpUtil.isPromise(options.promise) || notFound.length) {
                    $body
                        .addClass('fp-animated-loading-container')
                        .html(fp.ui.renderTemplate('component/0/animated-loading.html'));
                }

                if(!bsModal.isShown) $modal.modal('show');

                // fpUtil.setModalHeight($modal, true);

                // $modal.find('.modal-body').on('keydown', function(e) {
                //     if(e.keyCode == 40) $body.scrollTop() + 10;
                //     if(e.keyCode == 38) $body.scrollTop() - 10;
                // });

                return notFound;
            }

            function showProductsModal(options) {
                //fp.log('showProductsModal', $.extend(true, {}, options));
                var $modal = options.$modal,
                    bsModal = _.getObject($modal.data('bs.modal')),
                    productIds = _.getArray(options.productIds),
                    products = _.getArray(options.products),
                    html = '',
                    $body = $modal.find('.modal-body .fp-modal-content'),
                    cache = fp.cache.product,
                    title = S.getString(options.title, fp.ui.locale('shared-products', 'Products')),
                    availableStatus = fpUtil.map.get('productStatus').get('available'),
                    fulfillmentType = fpUtil.map.get('fulfillmentType'),
                    fulfillmentTypeTemplate = '<div class="fp-item-fulfillment-type"><div class="fp-drop-ship-icon"></div></div>',
                    stateManager = fp.ui.router.stateManager,
                    routeStates = fpConfig.routeStates,
                    nuValConfig = _.getObject(fp.store.nu_val_config),
                    listManager = _.getObject(options.listManager, fp.listManager),
                    genericItemTemplate = fp.ui.getTemplate('component/0/item-generic-detail.html'),
                    itemDetailTemplate = fp.ui.getTemplate(fp.config.productDetailLayout),
                    enableQtyDropdown = fpConfig.enableQtyDropDown ? 'fp-is-qty-ddl' : '',
                    enableQtyDropdownWrap =  fpConfig.enableQtyDropDown ? 'fp-is-qty-ddl-wrap' : '',
                    fulfillmentTypeHtml,
                    productUrl,
                    otherAttributes,
                    nuValScoreHtml,
                    productAd,
                    productAdHtml,
                    item;

                fp.Component.destroyChildComponents(true, $body);

                $body.html('');

                if(_.size(productIds)) {
                    var hashedProducts = _.indexBy(products, 'id');
                    _.each(productIds, function (id) {
                        if (options.excludeInList && listManager.getItem(id, true)) {
                            return;
                        }

                        item = cache.items[id];
                        if (item && item.identifier && !hashedProducts[id]) {
                            products.push(item);
                        }
                    });
                }

                if(!products.length && options.closeWhenNoProductsFound) {
                    fp.ui.hideModal($modal);
                    return;
                }

                fpUtil.sort(products, 'popularity');

                if(fpConfig.enableMobile) {
                    html = fpUi.renderTemplate('component/0/product-list-list.html', {
                        items: products,
                        adConfig: fp.sponsoredAdConfig,
                        imageSize: 'small',
                        enableAddInstructions: true
                    });
                }
                else {
                    products = _.filter(products, function (item) {
                        item = fpUtil.getProduct(item);
                        if (item.status_id == availableStatus.id) {
                            productUrl = stateManager.href(routeStates.productDetail, {id: item.id}, {canonical_url: item.canonical_url});
                            fulfillmentTypeHtml = fulfillmentType.get(item.fulfillment_type_id).identifier == 'drop_ship' ? fulfillmentTypeTemplate : '';
                            otherAttributes = _.getObject(nuValConfig.prefix ? item.other_attributes : null);
                            nuValScoreHtml = '';
                            templateOptions = {
                                item: item,
                                itemUrl: productUrl,
                                disableGroup: true,
                                disableAdmin: true
                            };

                            productAd = options.hashedProductAds && options.hashedProductAds[item.id];
                            if (productAd) productAd.product = item;

                            productAdHtml = productAd && fp.sponsoredAdConfig && fp.sponsoredAdConfig.label ? '<div class="fp-tag fp-tag-ad">' + fp.sponsoredAdConfig.label + '</div>' : '';

                            if (options.fromSpot) templateOptions.fromSpot = true;

                            if (otherAttributes.nu_val_score) {
                                nuValScoreHtml = '<img src="' + nuValConfig.prefix + otherAttributes.nu_val_score + '-new-Blue-ShelfTag.gif" alt="New blue shelf tag" class="fp-item-other-nutrition-score" />';
                            }

                            if(options.mode == 'search' && options.substitutionMode) {
                                html += ' \
                                        <li class="fp-item ' + '" data-product-id="' + fpUtil.encodeForHtml(item.id) + '"> \
                                        <div role="group" aria-label="' + fp.ui.locale('product', 'Product') + '"> \
                                            <div class="fp-item-image" data-href="' + productUrl + '" data-action="product-image-link" > \
                                                <img src="' + fpUtil.getImageSrc(item, 'small') + '" width="64" height="64" alt="" /> \
                                                ' + nuValScoreHtml + ' \
                                            </div> \
                                            ' + fp.ui.renderTemplate(itemDetailTemplate, templateOptions) + ' \
                                            <button type="button" class="fp-btn fp-btn-secondary fp-btn-sm pull-right" data-action="add-substitution" data-product-id="' + fpUtil.encodeForHtml(item.id) + '">' + fp.ui.locale('shared-add', 'Add') + '</button> \
                                        </div> \
                                    </li> \
                                ';
                                return true;
                            }
                            else {
                                html += ' \
                                    <li class="fp-item ' + enableQtyDropdown + '" data-product-id="' + fpUtil.encodeForHtml(item.id) + '"> \
                                        <div role="group" aria-label="' + fp.ui.locale('product', 'Product') + '"> \
                                            <div class="fp-item-image" data-href="' + productUrl + '" data-action="product-image-link" > \
                                                <img src="' + fpUtil.getImageSrc(item, 'small') + '" width="64" height="64" alt="" /> \
                                                ' + nuValScoreHtml + ' \
                                                ' + productAdHtml + ' \
                                                ' + fulfillmentTypeHtml + ' \
                                            </div> \
                                        ' + fp.ui.renderTemplate(itemDetailTemplate, templateOptions) + ' \
                                            <div class="fp-item-action" data-product-id="' + fpUtil.encodeForHtml(item.id) + '"> \
                                                <span class="fp-btn-icon fp-btn-decrement" aria-label="' + fp.ui.locale('aria-remove-from-list', fp.config.removeFromListLabel +': '+ item.name) + '" role="button" tabindex="0"><span class="sr-only">' + fp.config.removeFromListLabel + '</span></span> \
                                                <span class="fp-btn-add">' + fpUtil.getItemButtonHtml(item) + '</span> \
                                                <span class="fp-btn-icon fp-btn-increment" aria-label="' + fp.ui.locale('aria-add-to-list', fp.config.addToListLabel +': '+ item.name) + '" role="button" tabindex="0"></span> \
                                            </div> \
                                        </div> \
                                    </li> \
                                ';

                                return true;
                            }
                        }
                    });

                    if(html) html = '<ul class="fp-product-list fp-product-list-sm ' + enableQtyDropdownWrap + '">' + html + '</ul>';
                }

                if(html && _.size(options.bannerAds)) {
                    // load banner ad module
                    html = '<div data-role="banner-ad" class="fp-margin-bottom"></div>' + html;
                }

                if(!html && !(options.mode == 'search' && options.isSearching)) {
                    if(options.mode == 'search' && options.substitutionMode) {
                        html = ' \
                            <div id="fp-add-to-order-instructions">' + fp.ui.locale('shared-type-in-substitute', 'Please type in the product you want to substitute. If we were unable to find the original prodcut, we will use this product to fulfill the requested item.') + '</div> \
                        ';
                    } 
                    else {
                        if(fpUtil.getBoolean(options.allowGenericItem, fp.store.allow_generic_item)) {
                            item = {id: fpUtil.getNewItemId(), note: options.note};

                            if (options.notFoundTemplate) {
                                html = fp.ui.renderTemplate(options.notFoundTemplate, {item: item});
                            }
                            else {
                                html = ' \
                                    <div class="fp-margin-bottom"> \
                                        <div id="fp-add-to-order-instructions">' + fp.ui.locale('shared-type-in', 'Please type in the product you want added to your list. You can change the quantity after you add it.') + '</div> \
                                        <div class="fp-notification fp-error fp-margin-top"><div class="fp-icon-error"></div><div class="fp-notification-message">' + fp.ui.locale('shared-item-is-required', 'Item is required.') + '</div></div> \
                                    </div> \
                                    <ul class="fp-product-list fp-product-list-sm fp-product-list-not-found">' + fp.ui.renderTemplate(genericItemTemplate, {item: item}) + '</ul> \
                                ';
                            }
                        }

                        if(!html && !options.disableNoProductsFound){
                            //title = 'No Matching Products';
                            if(options.mode == 'search' && !$modal.find('input[name="fp-input-search"]').val()) {
                                html = ' \
                                    <div id="fp-add-to-order-instructions">' + fp.ui.locale('shared-type-in', 'Please type in the product you want added to your list. You can change the quantity after you add it.') + '</div> \
                                ';
                            }
                            else {
                                html = fp.ui.renderTemplate(options.notFoundTemplate || 'component/0/result-not-found.html', {type: fp.ui.locale('shared-products-low', 'products')});
                            }
                        }
                        else {
                            html = '<span class="hidden"></span>';
                            $body.parent().find('> .fp-modal-intro hr').remove();
                        }
                    }
                }

                if(options.enableAddAll) {
                    html += '<div class="fp-add-all-wrap fp-text-right"><button class="fp-btn fp-btn-add-all-items" data-action="add-all-products">' + fp.ui.locale('shared-add-all-products', 'Add All Products to List') + '</button></div>';
                }

                var $header = $modal.find('.modal-header'),
                    $subTitle = $header.find('h5').addClass('hidden'),
                    bodyClass;

                $header.find('h3 span').html(title);
                if(options.subTitle) $subTitle.removeClass('hidden').find('span').html(options.subTitle);

                if(!html) {
                    bodyClass = 'fp-animated-loading-container';
                    html = fp.ui.renderTemplate('component/0/animated-loading.html');
                }

                $body
                    .removeClass('fp-animated-loading-container')
                    .addClass(bodyClass)
                    .html(html);

                //fpUtil.setModalHeight($modal, true);

                $modal.off('shown.bs.modal.productsModal hide.bs.modal.productsModal');

                if(!options.listName) options.listName = 'Products';
                
                if(products.length) {
                    if(fpConfig.enableMobile && $body.length) {
                       fp.lozad($body[0].querySelectorAll('img[data-src]')).observe();
                    }

                    if(!options.substitutionMode) {
                        var $actions,
                            productAction;

                        _.each(products, function(item, index) {
                            item = fpUtil.getProduct(item);
                            $actions = $body.find('.fp-item .fp-item-action[data-product-id=' + item.id + ']');
                            productAction = $actions.data('fp.ui.Component');
                            if(productAction) productAction.destroy();

                            productAd = options.hashedProductAds && options.hashedProductAds[item.id];
                            if(productAd) productAd.product = item;

                            new fp.ui.ProductActions($actions, {
                                item: item,
                                listManager: listManager,
                                listName: options.listName,
                                listPosition: index + 1,
                                onRefreshUI: options.onRefreshUI,
                                stopPropagation: !productAd
                            });
                        });
                    }

                    function onModalShown() {
                        $modal
                            .off('click', '[data-action="clip-offer"]')
                            .on('click', '[data-action="clip-offer"]', function(event) {
                                event.preventDefault();

                                var $this = $(this),
                                    item = _.findWhere(products, {id: $this.closest('.fp-item').attr('data-product-id')});

                                if(!(item && item.clippable_offer)) return;

                                if(item.clippable_offer.is_clipped) {
                                    fp.ui.showOfferModal(item.clippable_offer);
                                    return;
                                }

                                fp.ui.clipOffer(item.clippable_offer, {$button: $this, disableCouponUpSell: true, apiOptions: {errorSelector: $modal.find('.fp-error') }})
                                    .done(function() {
                                        var hashedProducts = _.indexBy(products, 'id'),
                                            product,
                                            $this;

                                        $body.find('.fp-item')
                                            .each(function() {
                                                $this = $(this);
                                                product = hashedProducts[$this.attr('data-product-id')];
                                                if((product && product.clippable_offer) && (product.clippable_offer.id == item.clippable_offer.id)) {
                                                    $this.find('[data-action="clip-offer"]')
                                                        .toggleClass('fp-is-offer-clipped', fpUtil.getBoolean(item.clippable_offer.is_clipped))
                                                        .toggleClass('fp-disabled', fpUtil.getBoolean(item.clippable_offer.is_clipped))
                                                         product.clippable_offer.is_clipped = true;
                                                }
                                            });
                                    });
                            })
                            .off('click', '[data-action="add-all-products"]')
                            .on('click', '[data-action="add-all-products"]', function(event) {
                                event.preventDefault();

                                var listManager = fp.listManager,
                                    firstProduct = _.find(products, function (item) {
                                        return !listManager.getItem(item.id, true);
                                    }),
                                    promiseAddAll;

                                if(firstProduct) {
                                    promiseAddAll = listManager.listItemAdd(null, {
                                            item: firstProduct
                                        })
                                        .then(function() {
                                            var promises = [],
                                                promiseAll;
                                            _.each(products, function (item) {
                                                if (item != firstProduct && !listManager.getItem(item.id, true)) {
                                                    promises.push(listManager.listItemAdd(null, {item: item}));
                                                }
                                            });

                                            if (promises.length) {
                                                var deferredList = $.Deferred();
                                                fp.one(fp.events.LIST_ITEMS_REFRESHED, deferredList.resolve);
                                                promises.push(deferredList.promise());
                                                promiseAll = $.when.apply($, promises);
                                            }

                                            return promiseAll;
                                        });

                                    new fp.ui.Loading({
                                        appendTo: this,
                                        promiseHide: promiseAddAll,
                                        enableEvents: true,
                                        showOnInstantiate: true,
                                        destroyOnHide: true
                                    });
                                }

                                $.when(promiseAddAll)
                                    .done(function() {
                                        fp.ui.closeActiveModal();
                                    });
                            })
                            .off('click', '[data-action="product-image-link"]')
                            .on('click', '[data-action="product-image-link"]', function(event) {
                                event.preventDefault();
                                stateManager.go($(this).attr('data-href'), null, {absolute: true});
                            });

                        fp.trigger(fp.events.TRACK_EVENT, _.defaults({
                            items: products,
                            listName: options.listName
                        }, fp.constants.trackingEvents.ViewItemList));
                    }
                    
                    if(bsModal.isShown) {
                        onModalShown();
                    }
                    else {
                        $modal.on('shown.bs.modal.productsModal', onModalShown);
                    }
                }
                else if(item){
                    var $item = $body.find('.fp-item'),
                        $actions = $item.find('.fp-item-action[data-list-item-id=' + item.id + ']'),
                        productAction = $actions.data('fp.ui.Component'),
                        $note = $item.find('textarea.fp-item-note');

                    if(productAction) productAction.destroy();

                    if($note.length) {
                        $actions.add($item.find('.fp-btn-save-note')).click(function(event) {
                            event.preventDefault();
                            var $error = $item.find('.fp-error').hide().first()
                                ,note = S($note.val()).trim().s;

                            if(note) {
                                if(!$(event.target).hasClass('fp-btn-save-note')) return;

                                var listItemId = $item.attr('data-list-item-id');
                                if(!listItemId) return;

                                fp.trigger(fp.events.LIST_ITEM_UPDATE, {listManager: listManager, item: {id:listItemId, note:note}});
                                $modal.modal('hide');
                            }
                            else {
                                event.stopImmediatePropagation();
                                $error.show();
                            }
                        });
                    }

                    function onRefreshUI(event, payload) {
                        if(fpUtil.getEventNs(event) == fp.events.LIST_ITEM_CHANGED) {
                            if(!payload.itemChangeSuccess) return;

                            var changeType = fpConstants.listItemChangeType,
                                id = payload.oldListItemId || payload.item.id,
                                newId;

                            switch(payload.itemChangeType) {
                                case changeType.ADD:
                                case changeType.INCREMENT:
                                    newId = payload.item.id;
                                    break;
                                case changeType.REMOVE:
                                    newId = fpUtil.getNewItemId();
                                    productAction.destroy();
                                    item = {id: newId, note: payload.item.note};
                                    productAction = new fp.ui.ProductActions($actions, {
                                        item: item,
                                        onRefreshUI: onRefreshUI
                                    });
                                    break;
                                //no default
                            }
                            $body.find('[data-list-item-id=' + id + ']').attr('data-list-item-id', newId);
                        }

                        var quantity = 0,
                            lm = fp.ui.ListManager;

                        if(bsModal.isShown) {
                            var listItem;
                            _.each(productIds, function(key) {
                                //need to get shopping list item so we can check quantity
                                listItem = listManager.getItem(key, true);
                                if(listItem) {
                                    quantity += lm.getItemQuantity(listItem, false, false, true);
                                }
                            });
                        }
                        if(_.isFunction(options.onRefreshUI)) options.onRefreshUI(event, payload);
                    }

                    productAd = options.hashedProductAds && options.hashedProductAds[item.id];
                    if(productAd) productAd.product = item;

                    productAction = new fp.ui.ProductActions($actions, {
                        item: item,
                        listManager: listManager,
                        listName: options.listName,
                        listPosition: options.listPosition,
                        onRefreshUI: onRefreshUI,
                        stopPropagation: !productAd
                    });
                }

                $modal.on('shown.bs.modal.productsModal', function(){
                    $modal.off('click.productsModal.fp contextmenu.productsModal.fp');

                    if(_.size(options.hashedProductAds)) {
                        fpUi.triggerTrackUrls(options.productAds);
                        fpUi.beaconOnLoadProduct(options.productAdsData);
                        // fpUi.beaconOnView(options.productAdsData, $modal, {onlyProducts: true});
                        fpUi.productsBeaconOnView(options.productAdsData, $modal);
                        fpUi.beaconOnClick(options.productAdsData, $modal);

                        $modal
                            .on('click.productsModal.fp contextmenu.productsModal.fp', '.fp-item .fp-item-price span.fp-price-link', function (event) {
                                if(event.type == 'click') {
                                    event.preventDefault();
                                    event.stopImmediatePropagation();
                                }

                                var productId = $(this).closest('.fp-item').attr('data-product-id');
                                if (!productId) return;

                                fpUi.onProductAdClick(event, options.hashedProductAds[productId]);
                            })
                            .on('click.productsModal.fp contextmenu.productsModal.fp', '.fp-item', function (event) {
                                var productId = $(this).attr('data-product-id');
                                if (!productId) return;

                                fpUi.onProductAdClick(event, options.hashedProductAds[productId]);
                            });
                    }

                    if(_.size(options.bannerAds)) {
                        fpUi.loadModule({
                            elementSelector: $modal.find('[data-role="banner-ad"]'),
                            name: 'banner-view-carousel',
                            zone_type: 'checkout_product_upsell_banner_top',
                            disableNavigation: true,
                            containerClass: ''
                        })
                        .then(function (module) {
                            return module.init();
                        });
                    }

                    $modal
                        .on('click.productsModal.fp', '[data-action="see-price-modal"]', function(event) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
     
                            var $this = $(this);
                            
                            fpUi.closeActiveModal();
                            fpUi.showShopIntentModal({
                                force: true,
                                fulfillmentIdentifier: 'price',
                                next:  $this.attr('href')
                            });
                        })
                        .on('click.productsModal.fp', '[data-action="add-instructions"]', function(event) {
                            event.preventDefault();

                            var $this = $(this).toggleClass('collapse-show'),
                                $parent = $this.closest('.fp-item');
                                
                            $parent.find('[data-role="add-instructions"]').toggleClass('show');
                            $parent.toggleClass('fp-active-instructions');
                        })
                        .on('click.productsModal.fp', '[data-action="add-substitution"]', function(event) {
                            event.preventDefault();
                            _.getFunction(options.onAddSubstitute)(_.findWhere(options.products, {id: $(this).attr('data-product-id')}));
                            fp.ui.closeActiveModal();
                        });
                });

                if(_.isFunction(options.onAddSubstitute)) {
                    $modal
                        .off('click.productsModal.fp', '[data-action="add-substitution"]')
                        .on('click.productsModal.fp', '[data-action="add-substitution"]', function(event) {
                            event.preventDefault();
                            options.onAddSubstitute(_.findWhere(options.products, {id: $(this).attr('data-product-id')}));
                            fp.ui.closeActiveModal();
                        });
                }

                if(_.isFunction(options.onClose)) {
                    $modal.on('hide.bs.modal.productsModal', options.onClose);
                }

                // $modal
                //     .off('click.fp.core.product')
                //     .on('click.fp.core.product', '.fp-item a', function(event) {
                //     var productId = $(this).closest('[data-product-id]').attr('data-product-id');
                //
                //     event.preventDefault();
                //     fp.trigger(fp.events.PRODUCT_DETAIL_MODAL_SHOW, {
                //         listManager: options.listManager,
                //         productId: productId,
                //         title: _.getObject(_.findWhere(products, {id: productId})).name
                //     });
                // });
            }

            fp
                .on(fp.events.PRODUCTS_MODAL_SHOW, function(event, options) {
                    options = $.extend({$modal: fp.$productsModal}, options);

                    var $modal = options.$modal.toggleClass('fp-modal-product-search', options.mode == 'search'),
                        bsModal = _.getObject($modal.data('bs.modal'));
                        
                    if(bsModal.isShown && !options.openedFromBannerAd) return;

                    if(_.isString(options.productIds)) options.productIds = $.trim(options.productIds).split(',');
                    if(_.isString(options.productUpcs)) options.productUpcs = $.trim(options.productUpcs).split(',');

                    var productIds = _.getArray(options.productIds),
                        productUpcs = _.getArray(options.productUpcs),
                        params = {
                            fields: fp.productFields
                        },
                        notFound = initShowProductsModal(options),
                        $body = $modal.find('.modal-body'),
                        $modalSearch = $body.find('> .fp-modal-search'),
                        scope = _.getObject($modal.data('fp-scope')),
                        promiseLoadProducts,
                        origProducts;

                    $modal.data('fp-scope', scope);

                    if(_.isFunction(scope.onSearchBeforeChange)) fp.off(fp.events.SEARCH_BEFORE_CHANGE, scope.onSearchBeforeChange);
                    if(_.isFunction(scope.onShown)) $modal.off('shown.bs.modal.productsModal', scope.onShown);

                    if(options.mode != 'search' || options.disableSearchForNoProducts) {
                        const component = $modalSearch.data('fp.ui.Component');
                        if(component) component.destroy();
                        $modalSearch.remove();
                        $modalSearch = $();
                    }

                    if(fpUtil.isPromise(options.promise)) {
                        promiseLoadProducts = options.promise
                            .then(function(resp) {
                                options.products = origProducts = resp.items;
                            });
                    }
                    else {
                        if (notFound.length) {
                            if (productUpcs.length) params.identifier = notFound.join(',');
                            else params.id = notFound.join(',');

                            promiseLoadProducts = fpService.productService
                                .get(params)
                                .then(function(resp) {
                                    origProducts = resp.items;

                                    var cache = fp.cache.product,
                                        item;

                                    _.each(resp.items, function(item) {
                                        cache.items[item.id] = item;
                                        if(productUpcs.length && item.identifier) productIds.push(item.id);
                                    });

                                    _.each(productIds, function(key) {
                                        item = cache.items[key];
                                        if(!item) cache.items[key] = {id: key};
                                    });

                                    options.productIds = productIds;
                                });
                        }
                        else {
                            origProducts = options.products;
                        }
                    }

                    if(/*!fpConfig.enableMobile && */options.mode == 'search') {
                        promiseLoadProducts = $.when(promiseLoadProducts)
                            .then(function() {
                                if(options.disableSearchForNoProducts && !_.size(origProducts)) {
                                    delete options.mode;
                                    return;
                                }

                                var promiseLoadSearch;
                                if (!$modalSearch.data('fp.ui.Component')) {
                                    if (!$modalSearch.length) {
                                        $modalSearch = $('<div class="fp-modal-search"></div>').insertBefore($body.find('> .fp-modal-content'));
                                    }

                                    var searchBoxConfig = _.firstObject(fpConfig.modules.searchBox);
                                    promiseLoadSearch = fp.ui.loadModule({
                                            elementSelector: $modalSearch,
                                            name: 'search-box',
                                            disableRouteChange: true,
                                            type: 'product',
                                            fixedSearchIcon: searchBoxConfig.fixedSearchIcon,
                                            disableDropdown: searchBoxConfig.disableDropdown,
                                            enableAutoResize: searchBoxConfig.enableAutoResize,
                                            disableAutoLoad: searchBoxConfig.disableAutoLoad,
                                            enableAutoLoadLocal: searchBoxConfig.enableAutoLoadLocal,
                                            version: searchBoxConfig.version,
                                            enableTypeahead: fpConfig.enableMobile,
                                            ariaDescribedBy: 'fp-add-to-order-instructions'
                                        })
                                        .then(function (module) {
                                            return module.init();
                                        });

                                    scope.onShown = function () {
                                        const component = $modalSearch.data('fp.ui.Component');
                                        if (component) component.reset();
                                    };
                                    $modal.on('beforeshown.bs.modal.productsModal', scope.onShown);
                                }

                                scope.onSearchBeforeChange = function (event, params) {
                                    if (params.type != 'product') return;

                                    if (!params.q) {
                                        options.products = origProducts;
                                        options.productIds = productIds;
                                        options.productUpcs = productUpcs;
                                        showProductsModal(options);
                                        return;
                                    }

                                    delete options.products;
                                    delete options.productIds;
                                    delete options.productUpcs;

                                    const component = $modalSearch.data('fp.ui.Component');
                                    if (component) component.busy();

                                    var payload = {
                                        q: fpUtil.getUndefinedIfEmpty(params.q),
                                        //sort: 'relevance',
                                        sort: 'popularity',
                                        limit: fpConstants.pager.ITEMS_PER_PAGE,
                                        fields: fp.productFields
                                    };

                                    if (params.department_id && S(payload.department_id).ne(fp.defaultDepartment.id)) {
                                        payload.department_id = params.department_id;
                                        payload.department_id_cascade = true;
                                    }
                                    if (_.isObject(options.listManager)) payload.store_id = options.listManager.getList().store_id;

                                    fpService.productService.get(payload)
                                        .done(function (resp) {
                                            options.products = resp.items;
                                            showProductsModal(options);
                                        })
                                        .always(function () {
                                            if (component) component.idle();
                                        });
                                };

                                fp.on(fp.events.SEARCH_BEFORE_CHANGE, scope.onSearchBeforeChange);

                                return promiseLoadSearch;
                            })
                            .always(function () {
                                var searchTerm;

                                if (options.mode == 'search') {
                                    searchTerm = S(options.searchTerm).trim().s;
                                    options.isSearching = !!searchTerm;
                                }

                                showProductsModal(options);

                                if (options.isSearching) {
                                    delete options.isSearching;

                                    var component = $modalSearch.data('fp.ui.Component');
                                    if (component) {
                                        component.$element.find('form[name="fp-search"] input[name="fp-input-search"]').val(searchTerm);
                                        var payload = component.getValue();
                                        payload.type = 'product';
                                        scope.onSearchBeforeChange(null, payload);
                                    }
                                }
                            });

                        //return;
                    }

                    $.when(
                        promiseLoadProducts,
                        fpUtil.map.load({
                            service: fpService.tagService,
                            payload: {
                                type: 'store_price_mode,product_status,sale_configuration_type,substitution_type'
                            }
                        })
                    )
                    .done(function() {
                        if(options.mode != 'search') showProductsModal(options);
                    });
                })
                .on(fp.events.PRODUCTS_MODAL_HIDE, function() {
                    fp.ui.hideModal(fp.$productsModal);
                });

            return $productsModal;
        }        
        ,initCouponsModal: function(persist) {
            //Coupon modal
            var $activeModal,
                $couponsModal = $(fpUi.renderTemplate('component/0/modal-coupons.html', null, null, true))
                    .modal({
                        show: false,
                        persist: persist
                    })
                    .on('show.bs.modal.coupons', function() {
                        $activeModal = fp.__$freshop.find('[data-role="modal-container"] .modal.in');

                        if ($activeModal.length && $activeModal[0] != $couponsModal[0]) {
                            $couponsModal.removeClass('fade in');
                            $activeModal
                                .hide()
                                .attr('aria-hidden', 'true')
                                .prev('.modal-backdrop').hide();
                        }
                        else $activeModal = null;
                    })
                    .on('shown.bs.modal.coupons', function() {
                        fp.one(fpUtil.formatString('{0}.bs.modal.coupons', fp.events.ROUTE_CHANGED), function() {
                            fp.ui.hideModal($couponsModal);
                        });

                        // for ada, better to remove aria-hidden when modal is display
                        fp.__$freshop.find('[data-role="modal-container"] .modal.in')?.removeAttr('aria-hidden');

                        // $(this)
                        //     .find('.modal-body')
                        //     .find('input[type="search"]:visible, input[type="text"]:visible, textarea:visible').first().focus();
                    })
                    .on('hide.bs.modal.coupons', function () {
                        if($activeModal) {
                            $activeModal
                                .show()
                                .removeAttr('aria-hidden')
                                .prev('.modal-backdrop').show();
                        }
                    })
                    .on('hidden.bs.modal.coupons', function() {
                        if($activeModal) {
                            // fp.__$freshop.addClass('modal-open');
                            $activeModal.closest('[data-role="modal-container"]').addClass('modal-open');
                            $activeModal = null;
                        }

                        fp.off(fpUtil.formatString('{0}.bs.modal.coupons', fp.events.ROUTE_CHANGED));
                    });

            function initShowCouponsModal(options) {
                var $modal = options.$modal,
                    bsModal = _.getObject($modal.data('bs.modal')),
                    $body = $modal.find('.modal-body > .fp-modal-content'),
                    title;

                options.title = options.title || title || fp.ui.locale('shared-products', 'Products');

                var $header = $modal.find('.modal-header'),
                    $subTitle = $header.find('h5').addClass('hidden');
                $header.find('h3 span').html(options.title);
                if(options.subTitle) $subTitle.removeClass('hidden').find('span').html(options.subTitle);

                var $intro = $body.parent().find('> .fp-modal-intro').empty();
                if(options.introContent) {
                    $intro.append(options.introContent);
                    $intro.append('<hr class="fp-margin-caps" />');
                }

                if(fpUtil.isPromise(options.promise)) {
                    $body
                        .addClass('fp-animated-loading-container')
                        .html(fp.ui.renderTemplate('component/0/animated-loading.html'));
                }

                if(!bsModal.isShown) $modal.modal('show');
            }

            function showCouponsModal(options) {
                //fp.log('showCouponsModal', $.extend(true, {}, options));
                var $modal = options.$modal,
                    coupons = _.getArray(options.coupons),
                    html = '',
                    $body = $modal.find('.modal-body .fp-modal-content').html(''),
                    title = S.getString(options.title, fp.ui.locale('shared-products', 'Products')),
                    itemDetailTemplate = fp.ui.getTemplate(fp.config.productDetailLayout);
                    
                if(!coupons.length && options.closeWhenNoCouponsFound) {
                    fp.ui.hideModal($modal);
                    return;
                }

                _.each(coupons, function (item) {
                    item = fpUtil.getProduct(item);
                    templateOptions = {
                        item: item,
                        disableGroup: true,
                        disableAdmin: true
                    };

                    html += ' \
                        <li class="fp-item" data-product-id="' + fpUtil.encodeForHtml(item.id) + '"> \
                            <div class="fp-item-image"> \
                                    <img src="' + item.cover_image_url + '" width="64" height="64" alt="' + item.name + '" /> \
                            </div> \
                        ' + fp.ui.renderTemplate(itemDetailTemplate, templateOptions) + ' \
                                <button type="button" class="fp-btn fp-btn-offer-clippable" data-action="clip-offer"> \
                                    <span class="fp-value-clip">' + fp.config.clipActionLabel + '<span class="fp-icon fp-icon-offer-clip"></span></span> \
                                    <span class="fp-value-clipped">Clipped <span class="fp-icon fp-icon-offer-clipped"></span></span> \
                                </button> \
                        ' + '</li>';
                });

                if(html) html = '<ul class="fp-product-list fp-product-list-sm">' + html + '</ul>';

                var $header = $modal.find('.modal-header'),
                    $subTitle = $header.find('h5').addClass('hidden'),
                    bodyClass;

                $header.find('h3 span').html(title);
                if(options.subTitle) $subTitle.removeClass('hidden').find('span').html(options.subTitle);

                if(!html) {
                    bodyClass = 'fp-animated-loading-container';
                    html = fp.ui.renderTemplate('component/0/animated-loading.html');
                }

                $body
                    .removeClass('fp-animated-loading-container')
                    .addClass(bodyClass)
                    .html(html);

                $modal.on('click', '[data-action="clip-offer"]', function(event) {
                    event.preventDefault();

                    var $this = $(this),
                        item = _.findWhere(coupons, {id: $this.closest('.fp-item').attr('data-product-id')});
                        
                    fp.ui.clipOffer(item, {$button: $this, disableCouponUpSell: true, apiOptions: {errorSelector: $modal.find('.fp-error') }})
                        .done(function() {
                            var hashedCoupons= _.indexBy(coupons, 'id'),
                                coupon,
                                $this;

                            $body.find('.fp-item')
                                .each(function() {
                                    $this = $(this);
                                    coupon = hashedCoupons[$this.attr('data-product-id')];
                                    if(coupon && coupon.id == item.id) {
                                        $this.find('[data-action="clip-offer"]')
                                            .toggleClass('fp-is-offer-clipped', fpUtil.getBoolean(item.is_clipped))
                                            .toggleClass('fp-disabled', fpUtil.getBoolean(item.is_clipped));
                                    }
                                });
                        });
                })

                $modal.off('shown.bs.modal.couponsModal hide.bs.modal.couponsModal');
                $modal.on('shown.bs.modal.couponsModal', function(){
                    $modal.off('click.couponsModal.fp contextmenu.couponsModal.fp');
                });

                if(_.isFunction(options.onClose)) {
                    $modal.on('hide.bs.modal.couponsModal', options.onClose);
                }
            }

            fp
                .on(fp.events.COUPONS_MODAL_SHOW, function(event, options) {
                    options = $.extend({$modal: fp.$couponsModal}, options);

                    var $modal = options.$modal.toggleClass('fp-modal-product-search', options.mode == 'search'),
                        scope = _.getObject($modal.data('fp-scope'));
                        
                    initShowCouponsModal(options);
                    $modal.data('fp-scope', scope);
                    showCouponsModal(options);
                })
                .on(fp.events.COUPONS_MODAL_HIDE, function() {
                    fp.ui.hideModal(fp.$couponsModal);
                });

            return $couponsModal;
        }
    });

    //helper functions

    function initEvents() {
        var onSetPageTitle = function(event, payload) {
            var title = fpUi.getPageTitle(payload && payload.title);
            fpUi.setPageTitle(title);

            if(title && fpConfig.metaDescription) {
                fpUi.setMetaDescription(fpConfig.metaDescription.replace('{title}', title));
            }
        };

        fp
            .on(fp.events.ROUTE_BEFORE_CHANGE, function (event, payload) {
                //fp.previousScrollTop = payload.fromState != payload.toState ? 0 : $(window.document).scrollTop();

                if(fp.loaded && payload.fromState != payload.toState) {
                    _.defer(function () {
                        if (event.isDefaultPrevented()) return;

                        // fpUtil.showProgress();
                        fpUi.closeActiveModal();
                    });
                }
            })
            .on(fp.events.ROUTE_CHANGED, function(event, payload) {
                var debug = {},
                    stateParams = payload.toParams,
                    prefCookie = {debug: null},
                    environmentKeys = ['isDev', 'isPreProd', 'isProd'];

                _.each(stateParams, function (value, key) {
                    if (!S(key).startsWith('debug_' && key.length > 6)) return;

                    debug[key.replace('debug_', '')] = value;
                });

                if (_.size(debug)) prefCookie.debug = debug;
                _.each(['log_jsonp', 'log_debug', 'log_error'], function (key) {
                    if (_.has(stateParams, key)) prefCookie[key] = fpUtil.getBoolean(stateParams[key]);
                });
                //if (_.has(stateParams, 'log_jsonp')) prefCookie.log_jsonp = fpUtil.getBoolean(stateParams.log_jsonp);
                //if (_.has(stateParams, 'log_debug')) prefCookie.log_debug = fpUtil.getBoolean(stateParams.log_debug);

                _.each(environmentKeys, function(key) {
                    if(_.has(stateParams, key)) {
                        prefCookie[key] = fpUtil.getBoolean(stateParams[key]);

                        if(prefCookie[key]) {
                            _.each(environmentKeys, function(value) {
                                if(value != key) prefCookie[value] = null;
                            });
                        }
                        else prefCookie[key] = null;
                    }
                });

                fp.setPrefCookie(prefCookie);

                if(!fp.isProd()) {
                    fpConfig.enableMultiplex = fpUtil.getBoolean(stateParams.enable_multiplex, fpConfig.enableMultiplex && !fp.isLocal());
                }

                fpUtil.initDepartment();

                if(fp.hasDigitalCoupon && payload.changedParams.offer_id) {
                    if(stateParams.offer_id) {
                        fp.one(fp.events.LOADED, function () {
                            const viewModule = fp.Module.getViewModule({configAttrs: {name: 'coupon'}, attrs: {initialized: true}});
                            let offer;
                            if(viewModule) offer = viewModule.getItem(stateParams.offer_id);
                            if(offer) {
                                fp.ui.showOfferModal(offer, {enableSearchParams: true, clip: stateParams.clip});
                            }
                            else {
                                fpService.offerService
                                    .get(stateParams.offer_id, {handleErrors: false})
                                    .done(function (resp) {
                                        if (resp.id) {
                                            fp.ui.showOfferModal(resp, {enableSearchParams: true, clip: stateParams.clip});
                                        }
                                    });
                            }
                        });
                    }
                }
                
                if(payload.changedParams.modal) {
                    fp.one(fp.events.LOADED, function() {                            
                        switch(stateParams.modal) {
                            case 'shop_intent':
                                fp.ui.showShopIntentModal({
                                    force: true,
                                    fulfillmentIdentifier: stateParams.modal_action
                                });
                                break;
                            case 'offer':
                                if(stateParams.modal_action_id) {
                                    fpService.offerService
                                        .get(stateParams.modal_action_id)
                                        .done(function(resp) {
                                            fp.ui.showOfferDetailModal(resp);
                                        });
                                }
                                break;
                            //no default
                        }
                    });
                }

                if(payload.changedParams.authentication) {                        
                    var selectedStoreId = '',
                        stateManager = fpUi.router.stateManager;

                    if(fp.store.id) selectedStoreId = fp.store.id;
                    if(!selectedStoreId) selectedStoreId = stateParams.store_id;

                    if(stateParams.authentication == 'guest') {
                        //activate guest mode
                        if(fp.user) {
                            if(fp.user.is_guest_user) {
                                if(stateParams.confirmation_enabled) guestModeSuccess();                                    
                            }
                            else activateGuestMode();
                        }
                        else activateGuestMode();

                        function activateGuestMode() {
                            var guestPayload = {
                                is_guest_user: true,
                                store_id: fp.store.parent_id,
                                selected_store_id: selectedStoreId
                            };

                            if(stateParams.email) guestPayload.email = stateParams.email;
                            
                            fpService.userService
                                .post(guestPayload)
                                .then(function(resp) {
                                    fp.setUser(resp);

                                    fp.initLogin({
                                        autoRedirect: false
                                    }).then(function(){
                                        if(stateParams.confirmation_enabled) guestModeSuccess();
                                        else {
                                            if(fp.config.enableKiosk) stateManager.go(fp.config.guestLoginNext, null, {absolute: true});
                                                else stateManager.go(stateManager.states.shop);
                                        }
                                    });
                                });
                        }

                        function guestModeSuccess() {
                            fp.trigger(fp.events.CONFIRM_MODAL_SHOW, {
                                title: 'Guest Mode Activated',
                                content: 'Guest mode has been activated for store (<strong>' + fp.store.name + '</strong>).',
                                confirmButtonLabel: 'Close',
                                cancelButtonLabel: '',
                                callback: function() {
                                    stateManager.go(stateManager.states.shop);
                                }
                            });
                        }
                    }
                }

                _.each(fp.popUpSettings?.config, function (popUp, key) {
                    fpUi.showPopUpModal(popUp, key);
                });
            })
            .on(fp.events.STATE_CHANGED, onSetPageTitle)
            .on(fp.events.PAGE_TITLE_SET_CONTENT, onSetPageTitle)
            .one(fp.events.LOADED, function() {
                var processedAlerts = {};
                _.each(fp.alertQueue, function(item) {
                    if(!processedAlerts[item.options.type] || item.options.enableMultiple) {
                        if(processedAlerts[item.options.type]) item.options.handleScroll = false;
                        processedAlerts[item.options.type] = true;
                        fpUtil.showAlert(item.message, item.$alert, item.options);
                    }
                });
                fp.alertQueue.length = 0;

                var shopIntentConfig = fpConfig.shopIntent,
                    sessionCookie = fp.getSessionCookie();

                if(!fpUtil.isAuthenticated() && shopIntentConfig.enabled && (shopIntentConfig.displayOnLoad || shopIntentConfig.enableAgeGate)) {
                    var module = fp.Module.getViewModule(),
                        options = {};
                    if(!(module && module.config.enableShopIntentModal === false)) {
                        if (shopIntentConfig.enableAgeGate) {
                            if((!fpUtil.getBoolean(sessionCookie.ageGate) && !$(document.body).hasClass('fp-no-age-gate')) || (shopIntentConfig.displayOnLoad && !fp.store.id && !$(document.body).hasClass('fp-no-store-selection'))) {
                                if(!fpUtil.getBoolean(sessionCookie.ageGate) && fp.store.id) options.disableFulfillment = true;
                                options.force = true;
                            }
                        }
                        else if(shopIntentConfig.displayOnLoad && !shopIntentConfig.enableAgeGate) {
                            if(!fp.store.id && !$(document.body).hasClass('fp-no-store-selection')) {
                                options.force = true;
                            }
                        }
                        else {
                            var hostname = window.location.hostname,
                                lastViewedAt;
                            //age gate selected will not check last viewed at
                            //entering from referrer (that does not match current hostname) will not check last viewed at
                            if (S(window.document.referrer || hostname).contains(hostname)) {
                                lastViewedAt = sessionCookie.shopIntentModalLastViewedAt;
                            }
                            if (!lastViewedAt || dateFns.differenceInHours(new Date(), lastViewedAt) >= 24) {
                                options.force = shopIntentConfig.delivery && _.contains(shopIntentConfig.delivery.disallowedPostalCodes, fp.store.postal_code);
                            }
                        }
                    }

                    if (!fp.config.auto_store_select && _.size(options)) fpUi.showShopIntentModal(options);
                }

                fpUi.bindBodyEvents();

                fp.setSessionCookie({reload: null});

                delete fp.__promiseStoreDependencies;

                fpUi.initRecaptcha();

                //fp.log(_.size(fp.cache));
                //_.each(fp.cache, function(value, key) {
                //    if(value && !value.cacheDuringLoad) return;
                //    delete fp.cache[key];
                //});
                //fp.log(_.size(fp.cache));
            })
            .on(fp.events.PAGE_CHANGED, function(event, payload) {
                $(document.body).toggleClass('fp-is-logged-in', fpUtil.isAuthenticated());
            })
            .on(fp.events.ACCOUNT_LOGOUT, function(event, next) {
                next = S.getString(next, '/');
                fp.logout(next);
            })
            .on(fp.events.USER_CHANGED, function() {
                $.when($.ready)
                    .done(function () {
                        $(document.body).toggleClass('fp-is-logged-in', fpUtil.isAuthenticated());
                    });
            })
            .on(fp.events.STORE_CHANGE, function(event, options) {
                fp.storeChange(options);
            })
            .on(fp.events.CONFIRM_MODAL_SHOW, function(event, options) {
                var $modal = fp.__$freshop.find('[data-role="modal-container"] .fp-confirm-modal');

                if(!$modal.length) {
                    $modal = $('\
                            <div class="modal fp-confirm-modal fade" tabindex="-1" role="dialog" aria-modal="true"> \
                                <div class="modal-dialog"> \
                                    <div class="modal-content"> \
                                        <div class="modal-header fp-heading"> \
                                            <button type="button" class="close" data-dismiss="modal" aria-label="close modal"><span aria-hidden="true">&times;</span></button> \
                                            <h3 aria-level="1"><span>&nbsp;</span></h3> \
                                        </div> \
                                        <div class="modal-body clearfix"> \
                                            <div class="fp-notification" data-role="notification"></div> \
                                            <div class="fp-modal-content fp-margin-bottom"></div> \
                                            <button class="fp-btn fp-btn-close fp-btn-confirm pull-right">' + fp.ui.locale('shared-yes', 'Yes') + '</button> \
                                            <button class="fp-btn fp-btn-secondary fp-btn-close fp-btn-cancel fp-margin-right pull-right">' + fp.ui.locale('shared-no', 'No') + '</button> \
                                        </div> \
                                    </div> \
                                </div> \
                            </div> \
                        ')
                        .modal({
                            show: true
                        });
                }

                var answer = false,
                    callbackHandled = false,
                    $body = $modal.find('.modal-body'),
                    title = options.title || fp.ui.locale('shared-confirm', 'Confirm'),
                    content = options.content || '',
                    confirmButtonLabel = options.confirmButtonLabel || fp.ui.locale('shared-ok', 'OK'),
                    cancelButtonLabel = fpUtil.isNull(options.cancelButtonLabel) ? fp.ui.locale('shared-cancel', 'Cancel') : options.cancelButtonLabel;
                    //,scrollPos = 0;

                //fp.log('scrollPos', scrollPos);

                $modal
                    .removeClass()
                    .addClass('modal fp-confirm-modal fade ' + S.getString(options.cssClass))
                    .off('click.confirmModal')
                    .on('click.confirmModal', '.fp-btn-close, .close', function(event) {
                        var $this = $(this);
                        answer = $this.hasClass('fp-btn-confirm');

                        if(!options.customClose || ($this.hasClass('fp-btn-cancel'))) $modal.modal('hide');
                        else {
                            callbackHandled = true;
                            options.callback(answer);
                        }
                    })
                    .on('hidden.bs.modal', function (event) {
                        if(!callbackHandled) {
                            callbackHandled = true;
                            options.callback(answer);
                        }

                        // $('body').css({
                        //     overflow: '',
                        //     position: '',
                        //     top: ''
                        // }).scrollTop(scrollPos);

                        // fp.log('hidden.bs.modal scrollPos', scrollPos);
                        
                    })
                    .on('shown.bs.modal', function () {
                        if(options.onModalOpen) options.onModalOpen();

                        // scrollPos = $('body').scrollTop();
                        // $('body').css({
                        //     overflow: 'hidden',
                        //     position: 'fixed',
                        //     top : -scrollPos
                        // });

                        // fp.log('shown.bs.modal scrollPos', scrollPos);
                    });

                $modal.find('.fp-heading h3 span').html(title);
                $modal.find('.modal-body .fp-modal-content').html(content);
                $body.find('.fp-btn-confirm').html(confirmButtonLabel);

                if(cancelButtonLabel) $body.find('.fp-btn-cancel').removeClass('hidden').html(cancelButtonLabel);
                else $body.find('.fp-btn-cancel').addClass('hidden');

                $modal.modal('show');
            })
            .on(fp.events.CONFIRM_MODAL_HIDE, function(event) {
                var $modal = fp.__$freshop.find('[data-role="modal-container"] .fp-confirm-modal');
                if(!$modal.length) return;
                var bsModal = $modal.data('bs.modal');
                if(bsModal && bsModal.isShown) $modal.modal('hide');
            })
            //.on(fp.events.STORE_BEFORE_CHANGE, function(event, payload) {
            //    if(!fp.loaded) return;
            //
            //    var promise = fp.ui.getNavigationDependencies();
            //    if(!promise) return;
            //
            //    payload.clientParams.promises.push(promise);
            //})
            .on(fp.events.STORE_CHANGED, function(event, store) {
                var storeClass = fp.store.id ? fpUtil.formatString('fp-store-{0}', fp.store.id) : '';

                $(document.body).replaceClass(/fp-store-\S+/gim, storeClass, true)
                    .toggleClass('fp-has-store', !fpUtil.isNull(fp.store.id))
                    .toggleClass('fp-has-store-fulfillment', fp.hasStoreFulfillment());

                if(fp.loaded) {
                    //clear any active order
                    fp.clearOrderPreference();
                    fp.ui.loadStoreDependencies();
                }
            })
            .on(fp.events.LIST_ACTIVATED, function() {
                fp.clearOrderPreference();
            })
            /*.on(fp.events.LIST_REFRESHED, function(event, payload) {
                if(payload.listManager.getList().id != fp.listManager.getList().id) return;
                if(!payload.quantityTotal) fp.clearOrderPreference();
            })*/;
    }

    function initModals() {
        fp.$productsModal = fp.initProductsModal();
        fp.$couponsModal = fp.initCouponsModal();

        //all products confirmation modal
        fp.$addAllProductsModal = $('\
                <div class="modal fp-add-all-products-modal fade" tabindex="-1" role="dialog" aria-modal="true"> \
                    <div class="modal-dialog"> \
                        <div class="modal-content"> \
                            <div class="modal-header fp-heading"> \
                                <button type="button" class="close" data-dismiss="modal" aria-label="close modal"><span aria-hidden="true">&times;</span></button> \
                                <h3 aria-level="1"><span>&nbsp;</span></h3> \
                            </div> \
                            <div class="modal-body clearfix"> \
                                <div class="fp-modal-content fp-margin-bottom"></div> \
                                <a href="javascript:;" class="fp-btn fp-btn-close fp-btn-save pull-right">' + fp.ui.locale('shared-ok', 'OK') + '</a> \
                                <a href="javascript:;" class="fp-btn fp-btn-secondary fp-btn-close fp-margin-right pull-right">' + fp.ui.locale('shared-cancel', 'Cancel') + '</a> \
                            </div> \
                        </div> \
                    </div> \
                </div> \
            ')
            .modal({
                show: false
            });

        //add first product - add to favs modal
        fp.$firstProductsModal = $('\
                <div class="modal fp-add-all-products-modal fade" tabindex="-1" role="dialog" aria-modal="true"> \
                    <div class="modal-dialog"> \
                        <div class="modal-content"> \
                            <div class="modal-header fp-heading"> \
                                <button type="button" class="close" data-dismiss="modal" aria-label="close modal"><span aria-hidden="true">&times;</span></button> \
                                <h3 aria-level="1"><span>&nbsp;</span></h3> \
                            </div> \
                            <div class="modal-body clearfix"> \
                                <div class="fp-modal-content fp-margin-bottom"></div> \
                                <a href="javascript:;" class="fp-btn fp-btn-close fp-btn-add-favs pull-right">' + fp.ui.locale('shared-yes', 'Yes') + '</a> \
                                <a href="javascript:;" class="fp-btn fp-btn-secondary fp-btn-close fp-margin-right pull-right">' + fp.ui.locale('shared-no', 'No') + '</a> \
                            </div> \
                        </div> \
                    </div> \
                </div> \
            ')
            .modal({
                show: false
            });

        //product detail modal
        fp.$productDetailModal = $('\
                <div class="modal fp-product-detail-modal fade" tabindex="-1" role="dialog" aria-modal="true"> \
                    <div class="modal-dialog"> \
                        <div class="modal-content"> \
                            <div class="modal-header fp-heading"> \
                                <button type="button" class="close" data-dismiss="modal" aria-label="close modal"><span aria-hidden="true">&times;</span></button> \
                                <h3 aria-level="1" class="modal-title"><span>&nbsp;</span></h3> \
                            </div> \
                            <div class="modal-body clearfix"> \
                            ' + fp.ui.renderTemplate('component/0/animated-loading.html') + ' \
                                <div class="fp-modal-content fp-margin-bottom"> \
                                    <div class="fp-product-detail-content"></div> \
                                    <button class="fp-btn fp-btn-secondary fp-btn-close pull-right" data-dismiss="modal">' + fp.ui.locale('shared-close', 'Close') + '</button> \
                                </div> \
                            </div> \
                        </div> \
                    </div> \
                </div> \
            ')
            .modal({
                show: false
            });

        fp
            .on(fp.events.ADD_ALL_PRODUCTS_MODAL_SHOW, function(event, options) {
                var $modal = fp.$addAllProductsModal;
                if(!$modal) return;
                options = $.extend({}, options);
                var title = S.getString(options.title, fp.ui.locale('shared-add-products', 'Add Products To Shopping List'))
                    ,content = options.content || fp.ui.renderTemplate('component/0/add-products-to-list.html');
                $modal.find('.fp-heading h3 span').text(title);
                $modal.find('.modal-body .fp-modal-content').html(content);
                $modal
                    .off('click.addAllProductsModal')
                    .on('click.addAllProductsModal', '.fp-btn-close', function(event) {
                        fp.trigger(fp.events.ADD_ALL_PRODUCTS_MODAL_HIDE);
                        if(_.isFunction(options.callback)) {
                            var promise = options.callback(event);
                            if(!options.disableTrackItemsAdded && fpUtil.isPromise(promise)) {
                                var listItems = $.extend([], fp.listManager.selectedList.items);
                                promise.done(function(){
                                    var addedItems = [],
                                        hashedListItems = _.indexBy(listItems, 'id');
                                    _.each(fp.listManager.selectedList.items, function (item) {
                                        if(!_.has(hashedListItems, item.id)) addedItems.push(item);
                                    });

                                    fp.trigger(fp.events.LIST_ITEMS_ADDED, {
                                        listManager: fp.listManager,
                                        selectedList: fp.listManager.selectedList,
                                        addedItems: addedItems
                                    });
                                });
                            }
                        }
                    })
                    .modal('show');
            })
            .on(fp.events.ADD_ALL_PRODUCTS_MODAL_HIDE, function(event) {
                fp.ui.hideModal(fp.$addAllProductsModal);
            })
            .on(fp.events.FIRST_PRODUCT_ADD_MODAL_SHOW, function(event, options) {
                var $modal = fp.$firstProductsModal;
                if(!$modal) return;

                options = $.extend({}, options);
                var title = S.getString(options.title, 'Add All Favorites')
                    ,content = options.content || ' \
                        <div class="fp-text-left"> \
                        ' + fp.ui.locale('shared-added-item', '<p>You added an item to a new list. Would you like to fill the list with your favorite items?</p><p>If yes, one of every item marked with a filled-in star from the product pages will be added to your shopping list. Your favorites are gathered from items that you have marked with a filled-in star or that you have previously ordered.</p><p>Be sure to go in and review your list where you can then increase quantities and remove or add items.</p>') + ' \
                        </div> \
                    ';
                $modal.find('.fp-heading h3 span').text(title);
                $modal.find('.modal-body .fp-modal-content').html(content);
                $modal.off('click.firstProductsModal')
                    .on('click.firstProductsModal', '.fp-btn-close', function(event) {
                        if(_.isFunction(options.callback)) options.callback(event);
                    })
                    .modal('show');
            })
            .on(fp.events.FIRST_PRODUCT_ADD_MODAL_HIDE, function(event) {
                fp.ui.hideModal(fp.$firstProductsModal);
            })
            .on(fp.events.PRODUCT_DETAIL_MODAL_SHOW, function(event, options) {
                var $modal = fp.$productDetailModal;
                if(!$modal) return;

                options = $.extend({title: '&nbsp;'}, options);

                var $heading = $modal.find('.fp-heading h3 span').html(options.title)
                    ,$body = $modal.find('.modal-body').addClass('fp-animated-loading-container')
                    ,$modalContent = $body.find('.fp-modal-content')
                    ,$productDetailContent = $modalContent.find('.fp-product-detail-content')
                    ,bsModal = _.getObject($modal.data('bs.modal'));

                if(!bsModal.isShown) {
                    $productDetailContent.html('');
                    $modalContent.addClass('invisible');
                }

                var moduleConfig = {
                    name: 'product-detail',
                    elementSelector: $productDetailContent,
                    intent: 'modal',
                    disableExtras: options.disableExtras,
                    productId: options.productId,
                    listItemId: options.listItemId,
                    listManager: options.listManager,
                    varietyDefault: options.varietyDefault
                };
                _.defaults(moduleConfig, fpConfig.modules.productDetail);

                fp.ui.loadModule(moduleConfig)
                    .then(function (module) {
                        return module.init()
                            .done(function() {
                                $body.removeClass('fp-animated-loading-container');
                                $modalContent.removeClass('invisible');
                                $heading.html(fpUtil.encodeForHtml(S.getString(module.scope.item.name, fp.ui.locale('shared-product-detail', 'Product Detail'))));
                            });
                    });

                var $activeModal = fp.__$freshop.find('[data-role="modal-container"] .modal.in:not(.fp-product-detail-modal)')
                    .hide()
                    .attr('aria-hidden', 'true')
                    .removeClass('fade in'),
                    $modalBackdrop;

                if($activeModal.length) {
                    $modalBackdrop = fp.__$freshop.find('[data-role="modal-container"] .modal-backdrop').first().fadeOut('slow');
                }

                if(!moduleConfig.disableExtras) {
                    $modal.addClass('fp-media-sm');
                }

                $modal
                    .off('hide.bs.modal.productDetail hidden.bs.modal.productDetail')
                    .on('hide.bs.modal.productDetail', function() {
                        if(!$activeModal.length) return;

                        $activeModal
                            .show()
                            .removeAttr('aria-hidden')
                            .addClass('fade in');
                            
                        $modalBackdrop.css('display', '');

                        $modal.removeClass('fp-media-sm');
                    })
                    .on('hidden.bs.modal.productDetail', function() {
                        if($activeModal.length) fp.__$freshop.addClass('modal-open');
                        if(options.showMiniList) fp.trigger(fp.events.MINI_LIST_SHOW);

                        // use specifically for mini-list keyboard access, since the hover dropdown will close during modal popup
                        // which would not focus on anything after the popup is closed
                        if(options.alwaysFocus) options.focusElement?.focus();
                        // when set quality to 0, the minus button is hidden, which would remove focus when the product modal is closed
                        // use foucsElement to set focus when the situation happens.
                        else if(fp.ui.ListManager.getItemQuantity(options.item) < 1) options.focusElement?.focus();
                    })
                    .on('shown.bs.modal.productDetail', function() {
                        // for ada, better to remove aria-hidden when modal is display
                        $modal.removeAttr('aria-hidden');
                    })
                    .modal('show');
            })
            .on(fp.events.PRODUCT_DETAIL_MODAL_HIDE, function(event, options) {
                fp.ui.hideModal(fp.$productDetailModal);
            });
    }

    function initMatchMedia() {
        if (!window.matchMedia) return;

        var matchMedia = window.matchMedia,
            matchMediaMin = fpConstants.matchMediaMin,
            matchMediaMax = fpConstants.matchMediaMax,
            matchMediaMinValues = fpUtil.sort(_.values(matchMediaMin)),
            invertMatchMediaMin = _.invert(matchMediaMin),
            initMatch;

        function matchMediaWidth(mql, init) {
            if(init && initMatch) return;
            if(!mql.matches) return;

            var newWidth = 0,
                oldWidth = matchMediaMin[fp.device.screen],
                keyLowered;

            for(var key in matchMediaMin) {
                keyLowered = key.toLowerCase();
                if(mql.media.indexOf(matchMediaMin[key].toString()) >= 0) {
                    newWidth = matchMediaMin[key];
                    fp.device[keyLowered] = true;
                    fp.device.screen = key;
                    initMatch = true;
                }
                else if(mql.media.indexOf(matchMediaMax[key + '_MAX'].toString()) >= 0) {
                    newWidth = matchMediaMin[key];
                    fp.device[keyLowered] = true;
                    fp.device.screen = key;
                }
                else fp.device[keyLowered] = false;
            }

            if(oldWidth != newWidth) {
                fp.trigger(fp.events.MEDIA_WIDTH_CHANGE, {oldWidth:oldWidth, newWidth:newWidth});
            }
        }

        //loop through screens sizes smallest to largest
        var mql;
        _.each(matchMediaMinValues, function(key) {
            mql = matchMedia(fpUtil.formatString('screen and (min-width: {0}px)', key));
            if (mql) { // IE fix
                mql.addListener(matchMediaWidth);
                matchMediaWidth(mql);
            }
        });

        //loop through screens sizes largest to smallest
        _.each(fpUtil.sort(matchMediaMinValues, null, true), function(key) {
            mql = matchMedia(fpUtil.formatString('screen and (max-width: {0}px)', matchMediaMax[invertMatchMediaMin[key] + '_MAX']));
            if (mql) { // IE Fix
                mql.addListener(matchMediaWidth);
                matchMediaWidth(mql, true);
            }
        });

        mql = matchMedia('screen and (orientation:portrait)');
        if (mql) {
            function matchMediaPortrait(mql) {
                var $body = $(document.body);
                fp.device.portrait = mql.matches;
                $body.toggleClass('fp-portrait', fp.device.portrait);
            }

            mql.addListener(matchMediaPortrait);
            matchMediaPortrait(mql);
        }
    }
})();